import {
  ActionIcon,
  Box,
  Button,
  Checkbox,
  Collapse,
  ComboboxItem,
  Fieldset,
  Flex,
  Group,
  Menu,
  Modal,
  NumberFormatter,
  Pagination,
  Select,
  Switch,
  Table,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import {
  useDebouncedState,
  useDebouncedValue,
  useDisclosure,
  useHotkeys,
  useMediaQuery,
  useScrollIntoView,
} from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconCheck,
  IconDeviceFloppy,
  IconMaximize,
  IconMaximizeOff,
  IconMenu2,
  IconPencilDiscount,
  IconPrinter,
  IconSearch,
  IconTrash,
  IconX,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import moment from "moment";
import * as React from "react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import {
  paginationPageSize,
  paginationPageSizeSelector,
  repositoryDelivery,
  repositoryMdm,
  repositoryPayment,
  repositoryPos,
} from "../../../../_base/_const/_constVar";
import _breadcrumb from "../../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { anyAsciiCode } from "../../../../_base/helper/AnyAscii";
import { _localization } from "../../../../config/location";
import { sky_blue } from "../../../../const/variables";
import { MessageResponse } from "../../../../model/MessageResponse";
import { OrderDetailOutWardNew } from "../../../../model/SaleOrderModel";
import {
  TblInventorySerialItemDetailOnHand,
  TblInventorySerialOrderDetailOnHand,
} from "../../../../model/TblInventorySerialOnHand";

import {
  detailOrderForOutWardModel,
  TblOutward,
  TblOutwardDetail,
} from "../../../../model/TblOutWard";
import {
  getProvinceSelectNew,
  getTblInventoryTransactionTypeOutWard,
} from "../../../../service/getSelectApi";
import {
  createZnsPayload,
  sendZnsMessage,
  ZNS_TEMPLATE_IDS,
} from "../../../../service/znsService";
import PrintMfgWip from "../../MfgWip/PrintMfgWip/PrintMfgWip";
import FifoWarningModal from "../components/FifoWarningModal";
import RequestProductionOutWard from "../components/RequestProductionOutWard";
import RequestTransferOutWard from "../components/RequestTransferOutWard";
import RequestTransferOutWarDaccessory from "../components/RequestTransferOutWarDaccessory";
import RequestVendorReturnOutWard from "../components/RequestVendorReturnOutWard";
import SaleOrderOutward from "../components/SaleOrderOutward";
import useDynamicHeight from "../hooks/useDynamicHeight";
import { Inventory } from "../interface/interfaceInvertory";
import { outward } from "../services";
import { getActionFromPath } from "../utils";
import PrintPrOutWard from "./PrintPage/PrintPrOutWard";
import PrintXDCCNSerial from "./PrintPage/PrintXDCCNSerial";
import PrintWarehouseOutWard from "./PrintWarehouseOutWard";
//chi
import { AG_GRID_LOCALE_VN } from "@ag-grid-community/locale";
import { IconDownload } from "@tabler/icons-react";
import {
  CellValueChangedEvent,
  ColDef,
  DefaultMenuItem,
  GetContextMenuItemsParams,
  IRichCellEditorParams,
  MenuItemDef,
  themeQuartz,
} from "ag-grid-community";
import { AgGridReact, CustomCellRendererProps } from "ag-grid-react";
import * as XLSX from "xlsx";
import { DemoExportExcel } from "../../WarehouseInwardNew/pages/DemoExportExcel/DemoExportExcel";
import { SerialOnHand } from "../../WarehouseInwardNew/pages/warehouseInWardSerialChildren/warehouseInterFace";
import OptionPrintHandover from "./PrintPage/OptionPrintHandover";
import OptionPrintOutWard from "./PrintPage/OptionPrintOutWard";
import PrintHandover from "./PrintPage/PrintHandover";

import axios from "axios";
import {
  createAhamoveOrder,
  createGrabExpressDelivery,
} from "../../../../api/apiDeliveryPartner";
import { SelectListItem } from "../../../../model/SelectListItem";
import ModalTotalBoxGHTK from "../components/ModalTotalBoxGHTK";
import PrintTheTMDT from "./PrintPage/PrintTheTMDT";
import PrintWarehouseLKLR from "./PrintPage/PrintWarehouseLKLR";
import { WarehouseOutWardSerialChildrenV2 } from "./warehouseOutWardSerialChildrenV2";

interface OrderDetail {
  cod: number;
  shippingVendor: string;
  customerId: number;
  customerName: string;
  telephoneNumber: string;
  customerAddress: string;
  customerProvinceId: string;
  customerDistrictId: string;
  customerCommuneId: string;
  deliveryAppointmentTime: string; // ISO 8601 format
  typeShip: string;
  timeDelivery: string;
  timeDeliveryTime: number;
  sourceType: number;
  status: boolean;
  width: number;
  length: number;
  height: number;
  branchId: number;
  newCommuneId: number;
}
export interface TblInventorySerialOrderDetailOnHandEdit extends TblInventorySerialOrderDetailOnHand {
  type?: string;
  action?: string;
  poPrice1?: number;
  note?: string | null;

  totalAmount?: number;
}

interface InventoryItem {
  createBy: string | null;
  createByName: string | null;
  createDate: string | null;
  delivery: string | null;
  idPh: string | null;
  invId: number | null;
  invName: string | null;
  isNoSerial: boolean | null;
  itemCode: string | null;
  itemId: number | null;
  itemName: string | null;
  itemStatus: string | null;
  limitQuantity: number | null;
  note: string | null;
  poPrice: number | null;
  primaryQuantity: number | null;
  primaryUom: string | null;
  serial: string | null;
  soPrice1: number | null;
  soPrice2: number | null;
  sourceCode: string | null;
  sourceLineId: number | null;
  subQuantity: number | null;
  subSourceLineId: number | null;
  subUom: string | null;
  transactionQuantity: number | null;
  type: string | null;
}
export interface SerialItemLKLR {
  itemCode: string;
  itemId: number;
  itemName: string;
  parentSerial: string | null;
  serial: string;
  warranty: number;
  warrantyVendor: number;
}
const WarehouseOutWardActionV2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const isSmallScreen1250 = useMediaQuery("(max-width: 1250px)");

  // Location
  // Khi mở ở tab mới (window.open) thì location.state rỗng nên đọc fallback từ query string
  const sourceCode = location.state && location.state?.sourceCode;
  const transactionCode =
    (location.state && location.state?.transactionCode) ??
    searchParams.get("transactionCode");
  const sourceType =
    (location.state && location.state?.sourceType) ||
    location.state?.type ||
    searchParams.get("sourceType") ||
    searchParams.get("type");
  const locker =
    (location.state && location.state.isLocked) ??
    searchParams.get("isLocked") === "true";
  const id = location.state && location.state.id;
  // Search item
  const [take, setTake] = useState<number>(50);
  const pageSize = 10;
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  // Print
  const [currentDate, setCurrentDate] = useState<string>("");
  const [idPrint, setIdPrint] = useState<string | number>("");
  const [typePrint, setTypePrint] = useState<string | null>("");
  const [dataPrint, setDataPrint] = useState<any>(null);
  const scrollContainerRef = React.useRef<HTMLDivElement | null>(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [transitionSaveId, setTransitionSaveId] = useState(0);
  const [openModals, setOpenModal] = useState(false);
  const [statusReponse, setStatusReponse] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);

  //In phiếu xuất bán hàng
  const componentRef = React.useRef(null);
  const { scrollIntoView, targetRef } = useScrollIntoView<HTMLDivElement>({
    offset: 60,
  }) as {
    scrollIntoView: (options?: {
      alignment?: "start" | "end" | "center";
      offset?: number;
    }) => void;
    targetRef: React.RefObject<HTMLDivElement>;
  };
  const gridRef =
    React.useRef<AgGridReact<TblInventorySerialOrderDetailOnHandEdit>>(null);
  const [selectedRows, setSelectedRows] = useState<
    TblInventorySerialOrderDetailOnHandEdit[]
  >([]);

  const [workbook, setWorkbook] = useState<XLSX.WorkBook | null>(null);
  const [sheetNames, setSheetNames] = useState<string[]>([]);
  const [selectedSheets, setSelectedSheets] = useState<string[]>([]);
  const [idPrintCreate, setIdPrintCreate] = useState<number | null>(null); //state dùng để khi tạo tạo phiếu xuất kho thì sẽ hiển thị nút in phiếu
  const [valuePrintOptionModal, setValuePrintOptionModal] = useState<{
    option1: string;
    option2: string;
    dichVuDiKem: boolean;
    inLinhKienLR: boolean;
    inQR: boolean;
  }>(); // giá trị dc chọn từ modal in pxk
  const [valuePrintHandoverModal, setValuePrintHandoverModal] = useState(null); // giá trị dc chọn từ modal in biên bản xuất kho
  const [openPrintHandover, setOpenPrintHandover] = useState(false); //giá trị  để hiển thị file in biên bản , nếu sét là true thì hiển thị
  const [dataLinhKienLR, setDataLinhKienLR] = useState<SerialItemLKLR[] | null>(
    null,
  ); //dữ liệu linh kiện lắp ráp
  const [serialLKPrint, setSerialLKPrint] = useState<string | null>(null); //serial linh kiện lắp ráp để in
  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    pageStyle: `
      @page{
        size: A4;
       margin: 7mm 0 7mm 0;
      }
      body:{
        margin: 0;
        color: #000;
      }`,
    // onBeforePrint: () => console.log("Before printing..."),
    // onAfterPrint: () => console.log("After printing..."),
  });
  //lưu thông tin địa điểm nhận hàng khi đơn vị giao hàng khác nhận tại cửa hàng
  const [locationData, setLocationData] = useState<{
    provinceName?: any; // Thành phố
    districtName?: any; // Huyện
    wardName?: any; // Xã
    customerAddress?: any; // Địa chỉ
    customerName?: any; // Tên khách hàng
    telephoneNumber?: any; // Số điện thoại
  }>({});
  const [isReadyToPrint, setIsReadyToPrint] = useState(false); //Biến để refetch khi trước khi in để lấy tỉnh phường xã
  const [valueQRCode, setValueQRCode] = useState<string | null>(null);
  const [isReadyQrPrint, setIsReadyQrPrint] = useState(false);
  const shouldPrintQrRef = React.useRef(false); // ref để tránh stale closure khi đọc option inQR
  const [paymentSummaryForPrint, setPaymentSummaryForPrint] =
    useState<any>(null);
  //In những sản phẩm cần xuất kho để nv kho đi nhặt hàng
  const componentRef2 = React.useRef(null);
  const handlePrint2 = useReactToPrint({
    contentRef: componentRef2,
    pageStyle: `
       @page{
         size: A4;
        margin: 7mm 0 7mm 0;
       }
       body:{
         margin: 0;
         color: #000;
       }`,
    // onBeforePrint: () => console.log("Before printing..."),
    // onAfterPrint: () => console.log("After printing..."),
  });

  //In list sản phẩm linh kiện lắp ráp
  const componentRef3 = React.useRef(null);
  const handlePrintLK = useReactToPrint({
    contentRef: componentRef3,
    pageStyle: `
       @page{
         size: A4;
        margin: 7mm 0 7mm 0;
       }
       body:{
         margin: 0;
         color: #000;
       }`,
    // onBeforePrint: () => console.log("Before printing..."),
    // onAfterPrint: () => console.log("After printing..."),
  });
  //Phân trang search
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  // Action define
  const action = getActionFromPath(location?.pathname ?? "");
  //#region render ui outward
  const getOutWardProps = (additionalProps = {}) => ({
    dataSearchSourceCodeOption,
    dataPosition,
    dataInventoryByBranch,
    dataOutWard: dataOutWard?.tblItemTransactionHeaderCommand,
    dataOrderDetail: dataOrderDetail?.tblInventoryTransactionModel,
    handleChangeValueInput,
    setSourceCode,
    handleKeyDownSourceCode,
    sourceCode,
    isSave,
    searchSourceCode,
    setSearchSourceCode,
    isLocked: locker,
    haveSourceCode: sourceCode,
    action,
    updatedDataInventoryTransactionType,
    dataBranch: dataMasterOrg,
    ...additionalProps,
  });

  // Thong tin chung xuat lien chi nhanh
  const requestTransfetOutWard = () => {
    return (
      <RequestTransferOutWard
        {...getOutWardProps({
          haveStatus: true,
          isEdit: ["EDIT", "DETAIL"].includes(action),
          empManagerItem: dataEmployeeManagerItem,
        })}
      />
    );
  };

  // Thong tin chung xuat noi bo
  const requestTransferInternalOutWard = () => {
    return (
      <RequestTransferOutWard
        {...getOutWardProps({
          haveStatus: true,
          isEdit: ["EDIT", "DETAIL"].includes(action),
        })}
      />
    );
  };

  // Thong tin chung xuat ban hang
  const orderOutWard = () => {
    return (
      <SaleOrderOutward
        {...getOutWardProps({ isEdit: ["EDIT", "DETAIL"].includes(action) })}
      />
    );
  };

  // Thong tin chung xuat huy
  const cancelOutWard = () => {
    return (
      <RequestTransferOutWard
        {...getOutWardProps({
          isEdit: ["EDIT", "DETAIL"].includes(action),
          empManagerItem: dataEmployeeManagerItem,
        })}
      />
    );
  };

  // Thong tin chung xuat dieu chuyen serial
  const serialOutWard = cancelOutWard;

  // Thong tin chung xuat dieu chuyen noi bo serial
  const serialInternalOutWard = () => {
    return (
      <RequestTransferOutWard
        {...getOutWardProps({
          isEdit: ["EDIT", "DETAIL"].includes(action),
        })}
      />
    );
  };

  // Thong tin chung xuat kho dieu chinh
  const adjustmentOutWard = cancelOutWard;

  // Thong tin chung xuat kho tra ncc
  const returnVendorOutWard = () => {
    return (
      <RequestVendorReturnOutWard
        {...getOutWardProps({ isEdit: ["EDIT", "DETAIL"].includes(action) })}
      />
    );
  };

  // Thong tin chung xuat dieu chuyen lap rap
  const createProductOutWard = () => {
    return (
      <RequestProductionOutWard
        {...getOutWardProps({
          haveSourceCode: true,
          isEdit: ["EDIT", "DETAIL"].includes(action),
        })}
      />
    );
  };
  //Thông tin chung xuất điều chuyển linh kiện sản xuất
  const createTransferProduction = () => {
    return (
      <RequestTransferOutWarDaccessory
        {...getOutWardProps({
          haveSourceCode: true,
          isEdit: ["EDIT", "DETAIL"].includes(action),
        })}
      />
    );
  };
  //#endregion

  //#region state
  const outWardEntity = {
    sourceId: 0,
    tblItemTransactionHeaderCommand: {
      transactionId: 0,
      transactionCode: "",
      transactionDate: "",
      sourceCode: sourceCode || transactionCode || "",
      sourceType: sourceType || "",
      inventoryId: null,
      subInvId: null,
      departmentId: 0,
      status: "NEW",
      description: "",
      atribute1: "",
      atribute2: "",
      atribute3: "",
      atribute4: "",
      atribute5: "",
      atribute6: "",
      atribute7: "",
      atribute8: "",
      atribute9: "",
      atribute10: "",
      attribute11: "",
      attribute12: "",
      createBy: 0,
      createName: "",
      createDate: moment(new Date()).format("YYYY-MM-DD[T]HH:mm:ss"),
      lastUpdateDate: "",
      lastUpdateBy: 0,
    },
    serials: [],
  };

  const [dataOutWard, setDataOutWard] = useState<TblOutward>(outWardEntity);

  const [isError, setIsError] = useState(false);
  const [userInfo, setUserInfo] = useState<any>();

  //table state
  const entityOrderOutWard = {
    tblInventoryTransactionModel: {},
    inventoryTransactionRequestSourceModels: [],
    invCode: null,
    invId: null,
    invName: null,
    outWardCode: null,
    receiver: null,
    sourceCode: null,
    sourceId: null,
    subInvId: null,
    toAddess: null,
    newCommuneId: null, //đây là 2 id địa chỉ thành phố và phường xã cho khách hàng mới
    newProvinceId: null,
  };

  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [dataInventoryTransactionType, setDataInventoryTransactionType] =
    useState<ComboboxItem[]>([]);
  const [dataOrderDetail, setDataOrderDetail] =
    useState<OrderDetailOutWardNew>(entityOrderOutWard);
  console.log(
    "Check data Detail",
    dataOrderDetail?.inventoryTransactionRequestSourceModels,
  );
  // console.log("dataOrderDetailll", dataOrderDetail);
  // Dùng để lấy thành phố và xã mới
  const [dataCommuneMoi, setDataCommuneMoi] = useState<SelectListItem[]>([]);

  const [serial, setSerial] = useState<string>("");
  const [keySearch, setKeySearch] = useDebouncedState("", 300);
  const [debounced] = useDebouncedValue(keySearch, 300, { leading: true });
  const [searchSourceCode, setSearchSourceCode] = useDebouncedState("", 300);
  const [dataItem, setDataItem] = useState<
    TblInventorySerialItemDetailOnHand[]
  >([]);
  const [dataSearchSourceCodeOption, setDataSearchSourceCodeOption] = useState<
    any[]
  >([]);
  const [dataInventoryByBranch, setDataInventoryByBranch] = useState<
    Inventory[]
  >([]);
  const [dataSerialOnHand, setDataSerialOnHand] = useState<
    TblInventorySerialOrderDetailOnHandEdit[]
  >([]);
  const [dataPosition, setDataPosition] = useState<ComboboxItem[]>([]);
  const [checkDuplicateCode, setCheckDuplicateCode] = useState<string[]>([]);
  const [checkDuplicatePositionId, setCheckcDuplicatePositionId] = useState<
    number[]
  >([]);

  const [isExceedQuantity, setIsExceedQuantity] = useState(false);
  const [transactionTempId, setTransactionTempId] = useState(0);
  const [isSave, setIsSave] = useState(false);
  const [sourceCodeRef, setSourceCode] = useState(
    location.state && location.state.sourceCode,
  );
  const [isLockForOrder, setIsLockForOrder] = useState(true);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const containerRef = React.useRef<HTMLDivElement>(null);
  const sidePanelRef = React.useRef<HTMLDivElement>(null);
  const [isCollapse, { toggle: toggleCollapse }] = useDisclosure(false);
  const height = useDynamicHeight(headerRef, 200);
  const [mainContentWidth, setMainContentWidth] = useState(0);
  const [dataMasterOrg, setDataMasterOrg] = useState<any[]>([]);
  const [dataEmployeeManagerItem, setDataEmployeeManagerItem] = useState<any>(
    {},
  );

  //#endregion
  //Thay đổi khi có nhiều sourceType
  const changeSourceType =
    dataOutWard?.tblItemTransactionHeaderCommand?.sourceType;

  const renderMainOutWard = () => {
    const _sourceType =
      sourceType ?? dataOutWard.tblItemTransactionHeaderCommand.sourceType;
    switch (_sourceType) {
      case "XUAT_BAN":
        return orderOutWard();
      case "XUAT_DOI_TRA":
        return orderOutWard();
      case "XUAT_HUY":
        return cancelOutWard();
      case "XUAT_DIEU_CHINH":
        return adjustmentOutWard();
      case "XUAT_DIEU_CHUYEN_CHI_NHANH":
        return requestTransfetOutWard();
      case "XUAT_DIEU_CHUYEN_NOI_BO":
        return requestTransferInternalOutWard();
      // case "XUAT_CONG_CU_DUNG_CU":
      //   return requestTransferInternalOutWard();
      case "XUAT_DIEU_CHUYEN_CHI_NHANH_SERIAL":
        return serialOutWard();
      case "XUAT_DIEU_CHUYEN_NOI_BO_SERIAL":
        return serialInternalOutWard();
      case "XUAT_TRA_NCC":
        return returnVendorOutWard();
      case "XUAT_CONG_CU_DUNG_CU":
        return returnVendorOutWard();
      case "XUAT_KHAC":
        return returnVendorOutWard();
      case "XUAT_TRA_NCC-DCTT":
        return returnVendorOutWard();
      case "XUAT_MUON_BAO_HANH":
        return cancelOutWard();
      case "XUAT_LINH_KIEN_SAN_XUAT":
        return createProductOutWard();
      // case "XUAT_DIEU_CHUYEN_LINH_KIEN_SAN_XUAT":
      //   return createTransferProduction();
      case "XUAT_HOI_LINH_KIEN_SAN_XUAT":
        return requestTransfetOutWard();
      default:
        return requestTransfetOutWard();
    }
  };

  //#region impor

  const getColumnVisibility = () => {
    const _sourceType =
      sourceType ?? dataOutWard.tblItemTransactionHeaderCommand.sourceType;

    const defaultVisibility = {
      id: false,
      poPrice: true,
      subPrice: true,
      totalAmount: true,
      serial: false,
      limitQuantity: false,
    };

    if (
      ["XUAT_DIEU_CHUYEN_CHI_NHANH", "XUAT_DIEU_CHUYEN_NOI_BO"].includes(
        _sourceType,
      )
    ) {
      return {
        ...defaultVisibility,
        poPrice: false,
        subPrice: false,
        totalAmount: false,
        limitQuantity: false,
      };
    }

    if (_sourceType === "XUAT_LINH_KIEN_SAN_XUAT") {
      return {
        ...defaultVisibility,
        poPrice: true,
        subPrice: false,
        serial: false,
        subQuantity: false,
        subUom: false,
        primaryQuantity: false,
        limitQuantity: true,
      };
    }

    if (_sourceType?.includes("SERIAL") || _sourceType === "XUAT_HUY") {
      return { ...defaultVisibility, serial: true };
    }

    return defaultVisibility;
  };

  const updatedDataInventoryTransactionType = dataInventoryTransactionType.map(
    (item) => {
      if (
        ["XUAT_DIEU_CHUYEN_CHI_NHANH", "XUAT_DIEU_CHUYEN_NOI_BO"].includes(
          item.value,
        )
      ) {
        const cleanedLabel = item.label.replace(/\s*\(SL\)/g, "").trim();
        return { ...item, label: `${cleanedLabel} (SL)` };
      }
      return item;
    },
  );

  // func render ui => title
  const titleSell = () => {
    return (
      <>
        <Group mt={-10} align="center" justify={"space-between"}>
          <Tooltip label={"Ctrl + Shift + Z"} position="bottom">
            <Group align="center">
              {!isSmallScreen1250 ? (
                <Switch
                  size="lg"
                  color={isCollapse ? "red" : "green"}
                  checked={!isCollapse}
                  onLabel="Bật"
                  offLabel="Tắt"
                  onChange={toggleCollapse}
                  thumbIcon={
                    !isCollapse ? (
                      <IconMaximize
                        style={{ width: 16, height: 16 }}
                        stroke={2.5}
                        color="white"
                      />
                    ) : (
                      <IconMaximizeOff
                        style={{ width: 16, height: 16 }}
                        stroke={2.5}
                        color="white"
                      />
                    )
                  }
                />
              ) : (
                <></>
              )}
              {/* <Text size="md">
                  <Kbd>Ctrl</Kbd> + <Kbd>Shift</Kbd> + <Kbd>Z</Kbd>
                </Text> */}
            </Group>
          </Tooltip>
          <Flex
            gap="md"
            justify={{ sm: "flex-start", lg: "flex-end" }}
            wrap="wrap"
            align="center"
            direction="row"
          >
            {/* <Button
              leftSection={<IconArrowLeft size={14} />}
              color="gray"
              onClick={() => handleReturnPage()}
            >
              Quay lại
            </Button> */}
            <DemoExportExcel onLySerial={true} noSerialStatus={true} />
            <Button
              color="red"
              leftSection={<IconTrash size={14} />}
              rightSection={`(${selectedRows.length})`}
              onClick={handleDeleteSelected}
              disabled={
                ["DETAIL"].includes(action)
                  ? ["DETAIL"].includes(action)
                  : !selectedRows.length
              }
            >
              Xóa đã chọn
            </Button>
            {dataOutWard.tblItemTransactionHeaderCommand.attribute14 === "1"
              ? dataOutWard.tblItemTransactionHeaderCommand.sourceType ===
                  "XUAT_LINH_KIEN_SAN_XUAT" && (
                  <Button
                    variant="filled"
                    disabled={statusReponse}
                    leftSection={<IconX size={20} />}
                    color="#495057"
                    onClick={() => handleCancelTheSet()}
                  >
                    Hủy bộ
                  </Button>
                )
              : null}

            {changeSourceType === "XUAT_BAN" &&
            dataOutWard.tblItemTransactionHeaderCommand.status === "LOCK" &&
            location.pathname ===
              "/warehouse-config/detail-warehouse-out-ward" &&
            dataOutWard?.tblItemTransactionHeaderCommand?.tenCty !== null ? (
              <>
                <Button
                  leftSection={<IconDownload size={14} />}
                  color="violet"
                  onClick={() => handleDownLoadWord()}
                >
                  Tải biên bản bàn giao
                </Button>
                <Button
                  leftSection={<IconPrinter size={14} />}
                  onClick={() =>
                    openOptionPrintHandover(
                      location?.state.id,
                      location?.state?.type,
                    )
                  }
                >
                  In biên bản bàn giao
                </Button>
              </>
            ) : (
              <></>
            )}
            {/* hiển thị nút in khi vừa tạo xong phiếu xuất kho */}
            {dataOutWard.tblItemTransactionHeaderCommand.status === "LOCK" &&
              location.pathname ===
                "/warehouse-config/create-warehouse-out-ward" && (
                <>
                  {(changeSourceType === "XUAT_BAN" ||
                    changeSourceType === "XUAT_TRA_NCC" ||
                    changeSourceType === "XUAT_DOI_TRA" ||
                    changeSourceType === "XUAT_DIEU_CHUYEN_CHI_NHANH_SERIAL" ||
                    changeSourceType === "XUAT_DIEU_CHUYEN_CHI_NHANH" ||
                    changeSourceType === "XUAT_DIEU_CHUYEN_NOI_BO" ||
                    changeSourceType === "XUAT_DIEU_CHUYEN_NOI_BO_SERIAL") && (
                    <Button
                      leftSection={<IconPrinter size={14} />}
                      color="violet"
                      onClick={() => {
                        if (location?.state?.sourceType === "XUAT_BAN") {
                          idPrintCreate !== null &&
                            openPrintOptionModal(
                              idPrintCreate,
                              location?.state?.sourceType,
                            );
                        } else {
                          idPrintCreate !== null &&
                            onhandlePrint(
                              idPrintCreate,
                              location?.state?.sourceType,
                            );
                        }
                      }}
                    >
                      {location?.state?.sourceType === "XUAT_BAN"
                        ? "In phiếu xuất kho"
                        : location?.state?.sourceType === "XUAT_DOI_TRA"
                          ? "In phiếu xuất đổi trả"
                          : location?.state?.sourceType ===
                                "XUAT_DIEU_CHUYEN_CHI_NHANH_SERIAL" ||
                              location?.state?.sourceType ===
                                "XUAT_DIEU_CHUYEN_CHI_NHANH"
                            ? "In phiếu xuất điều chuyển CN"
                            : location?.state?.sourceType === "XUAT_TRA_NCC"
                              ? "In phiếu xuất trả NCC"
                              : location?.state?.sourceType ===
                                    "XUAT_DIEU_CHUYEN_NOI_BO" ||
                                  location?.state?.sourceType ===
                                    "XUAT_DIEU_CHUYEN_NOI_BO_SERIAL"
                                ? "In phiếu xuất điều chuyển nội bộ"
                                : ""}
                    </Button>
                  )}
                  {/* In đơn TMĐT */}
                  {changeSourceType === "XUAT_BAN" &&
                    dataOutWard.tblItemTransactionHeaderCommand
                      ?.ecommerceOrderId && (
                      <>
                        <PrintTheTMDT
                          // pdfUrl="https://content.pancake.vn/2-2510/2025/10/9/c15f1873900ab5324d1024821c77663a7418215c.c15f1873900ab5324d1024821c77663a7418215c"
                          autoPrint={false}
                          idPrintCreate={
                            dataOutWard.tblItemTransactionHeaderCommand
                              .ecommerceOrderId
                          }
                        />
                      </>
                    )}
                </>
              )}
            {/* Hiển thị nút in ở trang chi tiết : status là LOOK:đã xuất, là OPEN:lưu tạm */}
            {dataOutWard.tblItemTransactionHeaderCommand.status === "LOCK" &&
              location.pathname ===
                "/warehouse-config/detail-warehouse-out-ward" && (
                <>
                  {(changeSourceType === "XUAT_BAN" ||
                    changeSourceType === "XUAT_TRA_NCC" ||
                    changeSourceType === "XUAT_DOI_TRA" ||
                    changeSourceType === "XUAT_DIEU_CHUYEN_CHI_NHANH_SERIAL" ||
                    changeSourceType === "XUAT_DIEU_CHUYEN_CHI_NHANH" ||
                    changeSourceType === "XUAT_DIEU_CHUYEN_NOI_BO" ||
                    changeSourceType === "XUAT_DIEU_CHUYEN_NOI_BO_SERIAL") && (
                    <Button
                      leftSection={<IconPrinter size={14} />}
                      color="violet"
                      onClick={() => {
                        if (changeSourceType === "XUAT_BAN") {
                          openPrintOptionModal(
                            location?.state.id,
                            location?.state?.type,
                          );
                        } else {
                          onhandlePrint(
                            location?.state.id,
                            location?.state?.type,
                          );
                        }
                      }}
                    >
                      {changeSourceType === "XUAT_BAN"
                        ? "In phiếu xuất kho"
                        : changeSourceType === "XUAT_DOI_TRA"
                          ? "In phiếu xuất đổi trả"
                          : changeSourceType ===
                                "XUAT_DIEU_CHUYEN_CHI_NHANH_SERIAL" ||
                              changeSourceType === "XUAT_DIEU_CHUYEN_CHI_NHANH"
                            ? "In phiếu xuất điều chuyển CN"
                            : changeSourceType === "XUAT_TRA_NCC"
                              ? "In phiếu xuất trả NCC"
                              : changeSourceType ===
                                    "XUAT_DIEU_CHUYEN_NOI_BO" ||
                                  changeSourceType ===
                                    "XUAT_DIEU_CHUYEN_NOI_BO_SERIAL"
                                ? "In phiếu xuất điều chuyển nội bộ"
                                : ""}
                    </Button>
                  )}
                  {changeSourceType === "XUAT_LINH_KIEN_SAN_XUAT" && (
                    <Button
                      leftSection={<IconPrinter size={14} />}
                      color="violet"
                      onClick={() =>
                        onhandlePrint(
                          dataOutWard?.tblItemTransactionHeaderCommand
                            .transactionId ?? "",
                          location?.state?.type,
                        )
                      }
                    >
                      In phiếu xuất linh kiện
                    </Button>
                  )}

                  {/* In đơn TMĐT */}
                  {changeSourceType === "XUAT_BAN" &&
                    dataOutWard.tblItemTransactionHeaderCommand
                      ?.ecommerceOrderId && (
                      <>
                        <PrintTheTMDT
                          // pdfUrl="https://content.pancake.vn/2-2510/2025/10/9/c15f1873900ab5324d1024821c77663a7418215c.c15f1873900ab5324d1024821c77663a7418215c"
                          autoPrint={false}
                          idPrintCreate={
                            dataOutWard.tblItemTransactionHeaderCommand
                              .ecommerceOrderId
                          }
                        />
                      </>
                    )}
                </>
              )}

            <Button
              type="submit"
              color={sky_blue.base}
              leftSection={<IconDeviceFloppy size={16} />}
              disabled={
                dataOutWard.tblItemTransactionHeaderCommand.status === "LOCK" ||
                locker ||
                changeSourceType === "XUAT_LINH_KIEN_SAN_XUAT" ||
                dataSerialOnHand?.length === 0
              }
              onClick={() => {
                setIsSave(true);
                handleCreateOutWard("OPEN");
              }}
            >
              Lưu (Ctrl+S)
            </Button>
            <Button
              type="button"
              color="green"
              loading={isLoading}
              leftSection={<IconCheck size={16} />}
              disabled={
                dataOutWard.tblItemTransactionHeaderCommand.status === "LOCK" ||
                locker ||
                isLockForOrder ||
                dataSerialOnHand?.length === 0
              }
              onClick={() => {
                if (
                  (dataOrderDetail?.tblInventoryTransactionModel?.sourceType ===
                    "XUAT_DIEU_CHUYEN_CHI_NHANH" ||
                    dataOrderDetail?.tblInventoryTransactionModel
                      ?.sourceType === "XUAT_DIEU_CHUYEN_CHI_NHANH_SERIAL") &&
                  dataOrderDetail?.tblInventoryTransactionModel?.delivery &&
                  (dataOrderDetail?.tblInventoryTransactionModel?.delivery ===
                    "GHTK" ||
                    dataOrderDetail?.tblInventoryTransactionModel?.delivery ===
                      "GHTK (COD)")
                ) {
                  modalTotalBox();
                  setKeySearch("");
                } else {
                  handleCreateOutWard("LOCK", true);
                }
                // handleSendMessageOrderSuccsess();
              }}
            >
              Hoàn thành (Ctrl+Q)
            </Button>
            {/* In những sản phẩm cần để đi nhặt sản phẩm */}
            {location?.state?.sourceType === "XUAT_BAN" ||
            sourceType === "XUAT_BAN" ||
            sourceType === "XUAT_DIEU_CHUYEN_CHI_NHANH_SERIAL" ||
            sourceType === "XUAT_DIEU_CHUYEN_CHI_NHANH" ||
            sourceType === "XUAT_DIEU_CHUYEN_NOI_BO" ||
            sourceType === "XUAT_DIEU_CHUYEN_NOI_BO_SERIAL" ? (
              <div>
                <Menu shadow="md" width={250}>
                  <Menu.Target>
                    <Tooltip label="Nút tiện ích">
                      <ActionIcon size="md" variant="filled" color="blue">
                        <IconMenu2 size={20} />
                      </ActionIcon>
                    </Tooltip>
                  </Menu.Target>
                  <Menu.Dropdown>
                    <Menu.Item
                      leftSection={<IconPrinter size={20} />}
                      c="#000"
                      fw={600}
                      closeMenuOnClick={false}
                      onClick={() => handlePrint2()}
                    >
                      <Text size="sm" c="#000" fw={600}>
                        In những sản phẩm cần để đi nhặt sản phẩm
                      </Text>
                    </Menu.Item>
                  </Menu.Dropdown>
                </Menu>
              </div>
            ) : null}
          </Flex>
        </Group>
      </>
    );
  };

  // func render ui => select item outward
  const TableSelect = () => (
    <>
      <Table.ScrollContainer
        className="scroll-container"
        minWidth={500}
        h={500}
        type="native"
        ref={scrollContainerRef}
      >
        <Table w="100%" striped highlightOnHover>
          <Table.Thead>
            <Table.Tr>
              <Table.Th />
              <Table.Th>Mã vị trí</Table.Th>
              <Table.Th w={120} style={{ whiteSpace: "nowrap" }}>
                Tên vị trí
              </Table.Th>
              <Table.Th w={60} style={{ whiteSpace: "nowrap" }}>
                Mã sản phẩm
              </Table.Th>
              <Table.Th>Tên sản phẩm</Table.Th>
              <Table.Th>Số serial</Table.Th>
              <Table.Th style={{ whiteSpace: "nowrap" }}>Tuổi tồn</Table.Th>
              <Table.Th>Kho</Table.Th>
              <Table.Th style={{ whiteSpace: "nowrap" }}>Đơn vị tính</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {dataItem?.map((item) => {
              return (
                <Table.Tr
                  key={item.serial}
                  bg={
                    checkDuplicateCode.some((select) => select === item.serial)
                      ? "var(--mantine-color-blue-light)"
                      : undefined
                  }
                >
                  <Table.Td>
                    <Button
                      size="xs"
                      variant="filled"
                      onClick={() => {
                        handleRowSelection(
                          item.serial,
                          Number(item?.positionId),
                        );
                      }}
                      disabled={
                        checkDuplicateCode.includes(item.serial) &&
                        checkDuplicatePositionId.includes(
                          Number(item?.positionId),
                        )
                      }
                    >
                      {checkDuplicatePositionId.includes(
                        Number(item?.positionId),
                      ) &&
                      (checkDuplicateCode.includes(item.serial ?? "") ||
                        checkDuplicateCode.includes(item.itemCode ?? "") ||
                        checkDuplicateCode.includes(
                          String(item.sourceLineId) ?? "",
                        ))
                        ? "Đã chọn"
                        : "Chọn"}
                    </Button>
                  </Table.Td>
                  <Table.Td>{item.positionCode}</Table.Td>
                  <Table.Td>{item.positionName}</Table.Td>
                  <Table.Td>{item.itemCode}</Table.Td>
                  <Table.Td>
                    <Tooltip label={item.itemName}>
                      <Text size="sm" w={250} lineClamp={2} truncate="end">
                        {item.itemName}
                      </Text>
                    </Tooltip>
                  </Table.Td>
                  <Table.Td>{item.serial}</Table.Td>
                  <Table.Td>{item.itemAge}</Table.Td>
                  <Table.Td>
                    <Text size="sm" w={125} truncate="end">
                      {item.invName}
                    </Text>
                  </Table.Td>
                  <Table.Td>
                    {item.primaryUomName || item.primaryUomCode}
                  </Table.Td>
                </Table.Tr>
              );
            })}
          </Table.Tbody>
          <Table.Tfoot></Table.Tfoot>
          {dataItem.length < 1 && (
            <Table.Caption>Không tìm thấy sản phẩm!</Table.Caption>
          )}
        </Table>
      </Table.ScrollContainer>
      <Group m={10} justify="end">
        <Pagination
          total={totalPages}
          value={currentPage}
          withEdges
          onChange={handlePageChange}
          mt="sm"
        />
        {/* <Button
            onClick={() => {
              setTake((prevTake) => prevTake + 50);
            }}
            variant="transparent"
          >
            Xem thêm
          </Button> */}
      </Group>
    </>
  );

  // func render ui => text input transaction header
  const TextTransactionHeader = () => (
    <TextInput
      placeholder="Nhập mã vạch"
      w={200}
      disabled={
        dataOutWard.tblItemTransactionHeaderCommand.status === "LOCK" ||
        ["DETAIL"].includes(action)
      }
      value={anyAsciiCode(serial).toLocaleUpperCase()}
      onKeyDown={(e) => {
        if (e.key === " ") {
          e.preventDefault();
          return;
        }
        if (e.key === "Enter" && e.currentTarget.value.trim() !== "") {
          handleAddProduct();
        }
      }}
      onChange={(e) => setSerial(e?.currentTarget?.value)}
    />
  );

  const MenuDataOutWart = () => (
    <Menu
      opened={debounced.length > 2 && dataItem?.length !== 0}
      trapFocus={false}
      shadow="md"
      width={"900px"}
      position="bottom-start"
      offset={30}
    >
      <Menu.Target>
        <TextInput
          key={debounced}
          autoFocus
          style={{ width: "200px" }}
          defaultValue={debounced}
          leftSection={<IconSearch size={16} />}
          placeholder="Tìm kiếm mã sản phẩm"
          disabled={
            dataOutWard.tblItemTransactionHeaderCommand.status === "LOCK" ||
            ["DETAIL"].includes(action)
          }
          onChange={(e) => {
            const _key = e.currentTarget.value ?? "";
            setKeySearch(_key);
          }}
        />
      </Menu.Target>
      <Menu.Dropdown>
        <TableSelect />
      </Menu.Dropdown>
    </Menu>
  );

  const handleReturnPage = () => {
    navigate(-1);
  };

  const handleRowSelection = async (serial: string, positionId: number) => {
    const scrollableElement = document.querySelector(
      ".scroll-container",
    ) as HTMLElement | null;

    const postionScroll = scrollableElement?.scrollTop ?? 0;

    await fetchDataSerialOnHand(serial, positionId);

    if (scrollableElement) {
      setScrollPosition(postionScroll);
    }
  };

  const handleCancelTheSet = async () => {
    const dataCreate = {
      outWardId: dataOutWard.tblItemTransactionHeaderCommand.transactionId ?? 0,
      outWardTransactionCode:
        dataOutWard.tblItemTransactionHeaderCommand.transactionCode ?? "",
    };

    const response = await repositoryPos.post<MessageResponse<any>>(
      "/api/v1/TblMfgProductOrder/cancel-item",
      dataCreate,
    );
    if (response && response?.success) {
      setStatusReponse(response?.success);
      NotificationExtension.Success("Hủy thành công");
      return response;
    }
  };

  const handleKeyDownSourceCode = (e: any) => {
    if (e.key === "Enter" || e.key === "Tab") {
      if (dataSearchSourceCodeOption.length === 1) {
        handleChangeValueInput(searchSourceCode || "", "sourceCode");
      }
    }
  };

  const handleChangeValueInput = (
    value: null | string | boolean,
    key: string,
  ) => {
    setDataOutWard((prevData) => ({
      ...prevData,
      tblItemTransactionHeaderCommand: {
        ...prevData.tblItemTransactionHeaderCommand,
        [key]: value,
      },
    }));
  };

  const handleAddProduct = () => {
    if (dataOutWard.tblItemTransactionHeaderCommand?.sourceCode) {
      if (checkDuplicateCode.length === 0) {
        fetchDataSerialOnHand();
        setSerial("");
      } else if (checkDuplicateCode.length > 0) {
        if (checkDuplicateCode.includes(serial)) {
          NotificationExtension.Fails("Mã Serial đã được quét !");
        } else {
          setCheckDuplicateCode((prev) => [...prev, serial]);
          fetchDataSerialOnHand();
          setSerial("");
        }
      }
    } else {
      NotificationExtension.Fails("Chưa nhập số chứng từ");
    }
  };

  const deleteItemSerial = (serial: string, positionId?: number) => {
    setDataSerialOnHand((prevData) =>
      prevData.filter((item) => item?.serial !== serial),
    );
    setCheckcDuplicatePositionId((prevData) =>
      prevData.filter((item) => item !== positionId),
    );
    setCheckDuplicateCode((prevData) =>
      prevData.filter((item) => item !== serial),
    );
  };

  const checkVarianceItem = (
    items: detailOrderForOutWardModel[],
    checkQuantityBy: string,
  ) => {
    let hasVariance = false;
    const varianceItems: { itemName: string; varianceQuantity: number }[] = [];

    items.forEach((item) => {
      const scannedQuantity = item.scannedQuantity || 0;
      const baseQuantity = (item as any)[checkQuantityBy] || 0;

      const varianceQuantity = scannedQuantity - baseQuantity;
      if (varianceQuantity !== 0) {
        varianceItems.push({
          itemName: item.itemName,
          varianceQuantity,
        });
        hasVariance = true;
      }
    });

    return {
      isVariance: hasVariance,
      varianceItems,
    };
  };

  const openCofirmModal = (
    variaceItems: any[],
    isLocked: boolean,
  ): Promise<boolean> => {
    return new Promise((resolve) => {
      modals.openConfirmModal({
        size: "auto",
        withCloseButton: false,
        children: (
          <Box component="form" mx="auto" style={{ position: "relative" }}>
            <Text size="20px" fw={"bold"} my={10}>
              Có những sản phẩm sau có lệch? Bạn có chắc chắn{" "}
              {isLocked ? "hoàn thành" : "lưu"} phiếu?
            </Text>
            <Box mt={3}>
              <Table
                highlightOnHover
                striped
                withColumnBorders
                horizontalSpacing="md"
                verticalSpacing="sm"
                bd={"1px solid #E0E0E0"}
              >
                <thead>
                  <tr style={{ backgroundColor: "#F8F9FD" }}>
                    <th
                      style={{
                        textAlign: "left",
                        padding: "12px",
                        fontSize: "16px",
                        fontWeight: 600,
                        border: "1px solid #E0E0E0",
                      }}
                    >
                      Tên sản phẩm
                    </th>
                    <th
                      style={{
                        textAlign: "center",
                        padding: "12px",
                        fontSize: "16px",
                        fontWeight: 600,
                        border: "1px solid #E0E0E0",
                      }}
                    >
                      Số lượng lệch
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {variaceItems?.map((item, index) => {
                    const varianceQuantity = item.varianceQuantity || 0;
                    return (
                      <tr key={index}>
                        <td
                          style={{
                            padding: "12px",
                            fontWeight: "bold",
                            textAlign: "left",
                            border: "1px solid #E0E0E0",
                          }}
                        >
                          {item.itemName}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            textAlign: "center",
                            fontWeight: "bold",
                            color: "red",
                            border: "1px solid #E0E0E0",
                          }}
                        >
                          {varianceQuantity}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Box>

            <Group
              justify="end"
              mt="xs"
              style={{
                position: "sticky",
                bottom: 0,
                backgroundColor: "white",
              }}
            >
              <Button
                type="button"
                color="gray"
                onClick={() => {
                  handleChangeValueInput("", "status");
                  modals.closeAll();
                  resolve(false);
                }}
                leftSection={<IconX size={18} />}
              >
                Hủy
              </Button>
              <Button
                onClick={() => {
                  handleChangeValueInput("LOCK", "status");
                  modals.closeAll();
                  resolve(true);
                }}
                color={sky_blue.base}
                leftSection={<IconCheck size={18} />}
              >
                Xác nhận
              </Button>
            </Group>
          </Box>
        ),
        confirmProps: { display: "none" },
        cancelProps: { display: "none" },
        onClose() {
          handleChangeValueInput("", "status");
        },
      });
    });
  };

  const checkExceedQuantityFound = (
    data: any[],
    fieldCheckQuantity: string,
  ) => {
    const _sourceType = dataOutWard.tblItemTransactionHeaderCommand.sourceType;
    const _exceedQuantityFound =
      dataOrderDetail?.inventoryTransactionRequestSourceModels?.some(
        (order) => {
          const matchingOrder = data
            .filter((item) => {
              const checkItem = _sourceType?.includes("SERIAL")
                ? item.serial === order.serial ||
                  item.sourceLineId === order.sourceLineId
                : item.itemId === order.itemId ||
                  item.itemCode === order.itemCode ||
                  item.sourceLineId === order.sourceLineId;

              return checkItem;
            })
            .map((item) => item?.primaryQuantity || 0);

          if (matchingOrder.length > 0) {
            const totalQuantity = matchingOrder?.reduce(
              (acc, curr) => acc + curr,
              0,
            );
            const orderQuantity = (order as any)[fieldCheckQuantity] ?? 0;
            const remainQuantity = orderQuantity - totalQuantity || 0;
            return remainQuantity < 0;
          }

          return false;
        },
      );

    if (_exceedQuantityFound) {
      return true;
    }
    return false;
  };

  const fetchDataProvinceNew = async (idProvince: string) => {
    const res = await getProvinceSelectNew();

    if (res) {
      const data = res
        ?.filter((item) => item.id && item.name)
        ?.map((item) => ({
          value: String(item.id),
          label: String(item.name),
        }));

      return data.find((i) => String(i.value) === String(idProvince))?.label;
    }
  };

  const fetchDataCommuneNew = async (idProvince: string, idCommune: string) => {
    const dataSearch =
      idProvince && idProvince.length > 0 ? `&ProvinceIds=${idProvince}` : "";

    const res = await repositoryMdm.get<MessageResponse<any>>(
      `/api/v1/TblDmCommuneMoi/get-select?Active=true${dataSearch}`,
    );

    if (res && res.success) {
      const result = res.data;
      const dataSet = result
        ?.filter((item: any) => item.text && item.value)
        ?.map((item: any) => ({
          value: String(item.value),
          label: String(item.text),
        }));

      return dataSet.find((i: any) => String(i.value) === String(idCommune))
        ?.label;
    }
  };

  const fetchDataBranch = async () => {
    const res = await repositoryDelivery.get<MessageResponse<any>>(
      "/api/v1/TblDmMasterOrg/get-all",
    );

    if (res && res.success) {
      const data = res.data.map((i: any) => ({
        orgId: i.id,
        orgCode: i.code,
        pick_tel: i?.attribute11 ?? "",
        pick_address: i?.address ?? "",
        pick_province: i?.attribute8 ?? "",
        pick_ward: i?.attribute9 ?? "",
        pick_address_detail: i?.attribute10 ?? "",
      }));
      setDataMasterOrg(data);
    }
  };

  const handleSelectManagerItem = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      `/api/v1/TblRequestTransfer/detail?id=${dataOrderDetail?.tblInventoryTransactionModel?.sourceId}`,
    );

    if (res && res.success) {
      const data = res.data;
      setDataEmployeeManagerItem({
        empName: data.attribute15,
        telephoneNumber: data.attribute14,
      });
    }
  };

  useEffect(() => {
    if (
      dataOrderDetail?.tblInventoryTransactionModel?.sourceId &&
      (dataOrderDetail?.tblInventoryTransactionModel?.sourceType ===
        "XUAT_DIEU_CHUYEN_CHI_NHANH" ||
        dataOrderDetail?.tblInventoryTransactionModel?.sourceType ===
          "XUAT_DIEU_CHUYEN_CHI_NHANH_SERIAL") &&
      dataOrderDetail?.tblInventoryTransactionModel?.delivery &&
      dataOrderDetail?.tblInventoryTransactionModel?.delivery === "GHTK"
    ) {
      handleSelectManagerItem();
    }
  }, [dataOrderDetail?.tblInventoryTransactionModel?.sourceId]);

  const modalTotalBox = () => {
    modals.openConfirmModal({
      title: <Title order={5}>Khai báo số kiện hàng !</Title>,
      size: "50vw",
      children: (
        <ModalTotalBoxGHTK
          onSuccess={handleCreateOutWard}
          dataProducts={
            dataOrderDetail?.inventoryTransactionRequestSourceModels || []
          }
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handeOrderGHTK = async (totalBox?: number, products?: any[]) => {
    if (
      dataOutWard?.tblItemTransactionHeaderCommand?.sourceType === "XUAT_BAN"
    ) {
      const url = `/api/v1/CreateSellItem/details?orderNumber=${dataOutWard?.tblItemTransactionHeaderCommand?.sourceCode}`;
      const response = await repositoryPos.get<MessageResponse<any>>(url);

      if (response && response?.success) {
        const products = response.data?.orderDetail.map((item: any) => ({
          quantity: item.quality,
          weight: 0.1,
          product_code: item.itemId,
          name: item.itemName,
        }));

        const customerData = JSON.parse(response.data?.orderHeader?.attribute1);
        if (response.data?.orderHeader?.shipingVendor !== "Giao hàng tiết kiệm")
          return;

        if (
          response.data?.orderHeader?.attribute24 ===
            "Giao Hàng Thu Tiền(COD)" &&
          (response.data?.orderHeader.amountRemaining === 0 ||
            !response.data?.orderHeader.amountRemaining)
        ) {
          return NotificationExtension.Fails(
            "Đơn hàng này không có COD, không thể tạo đơn GHTK COD",
          );
        }

        const [provinceName, communeName] = await Promise.all([
          fetchDataProvinceNew(customerData.customerProvinceId),
          fetchDataCommuneNew(
            customerData.customerProvinceId,
            customerData.customerCommuneId,
          ),
        ]);

        if (!provinceName || String(provinceName).length === 0) {
          NotificationExtension.Fails("Tỉnh/TP không tồn tại !");
          return;
        }

        if (!communeName || String(communeName).length === 0) {
          NotificationExtension.Fails("Phường/xã không tồn tại !");
          return;
        }

        const dataWarehouse = dataMasterOrg.find(
          (i) => String(i.orgId) === String(response.data?.orderHeader?.orgId),
        );

        const [pickProvinceName, pickCommuneName] = await Promise.all([
          fetchDataProvinceNew(dataWarehouse.pick_province),
          fetchDataCommuneNew(
            dataWarehouse.pick_province,
            dataWarehouse.pick_ward,
          ),
        ]);

        const responseGHTK = await repositoryMdm.post<any>(
          "/api/v1/GHTK/create-order",
          {
            order: {
              products: products,
              order: {
                id: response.data?.orderHeader?.orderNumber,
                pick_name: "Nội thành Hà Nội",
                pick_address: dataWarehouse?.pick_address,
                pick_province: pickProvinceName,
                pick_district: null,
                pick_ward: pickCommuneName,
                pick_tel: dataWarehouse?.pick_tel,
                tel: customerData.telephoneNumber,
                name: customerData.customerName,
                address: customerData.customerAddress,
                province: provinceName,
                district: null,
                ward: communeName,
                hamlet: "Khác",
                is_freeship: "1",
                pick_money:
                  response.data?.orderHeader?.attribute24 ===
                  "Giao Hàng Thu Tiền(COD)"
                    ? (response.data?.orderHeader.amountRemaining || 0) -
                      (response.data?.orderHeader.deposit || 0)
                    : 0,
                note: "",
                value: response.data?.orderHeader.amountTotal,
                pick_option: "cod",
              },
            },
          },
        );

        if (responseGHTK?.success === true) {
          // Mã tra cứu đơn giờ do API create-order tự ghi vào attribute1,
          // chạy chung transaction với phần còn lại nên không cần gọi thêm ở đây
          NotificationExtension.Success("Tạo đơn GHTK thành công");
        } else {
          setTimeout(() => {
            NotificationExtension.Fails(
              `Tạo đơn GHTK thất bại: ${responseGHTK?.message}`,
            );
          }, 1000); // Delay 200ms

          // Ghi log lỗi vào hệ thống
          await repositoryPos.post("/api/v1/CreateSellItem/update-ghtk-log", {
            orderNumber: response.data?.orderHeader?.orderNumber,
            attribute42:
              responseGHTK?.message || "Lỗi không xác định khi tạo đơn GHTK",
          });
        }
      }
    } else if (
      (dataOrderDetail?.tblInventoryTransactionModel?.sourceType ===
        "XUAT_DIEU_CHUYEN_CHI_NHANH" ||
        dataOrderDetail?.tblInventoryTransactionModel?.sourceType ===
          "XUAT_DIEU_CHUYEN_CHI_NHANH_SERIAL") &&
      dataOrderDetail?.tblInventoryTransactionModel?.delivery &&
      (dataOrderDetail?.tblInventoryTransactionModel?.delivery === "GHTK" ||
        dataOrderDetail?.tblInventoryTransactionModel?.delivery ===
          "GHTK (COD)")
    ) {
      const dataFromBranch = dataMasterOrg.find(
        (i) =>
          String(i.orgId) ===
          String(dataOrderDetail?.tblInventoryTransactionModel?.fromBranchId),
      );

      const dataToBranch = dataMasterOrg.find(
        (i) =>
          String(i.orgId) ===
          String(dataOrderDetail?.tblInventoryTransactionModel?.toBranchId),
      );

      const [pickProvinceName, pickCommuneName, provinceName, communeName] =
        await Promise.all([
          fetchDataProvinceNew(dataFromBranch.pick_province),
          fetchDataCommuneNew(
            dataFromBranch.pick_province,
            dataFromBranch.pick_ward,
          ),
          fetchDataProvinceNew(dataToBranch.pick_province),
          fetchDataCommuneNew(
            dataToBranch.pick_province,
            dataToBranch.pick_ward,
          ),
        ]);

      const responseGHTK = await repositoryMdm.post<any>(
        "/api/v1/GHTK/create-order",
        {
          order: {
            products: products,
            order: {
              id:
                dataOrderDetail?.tblInventoryTransactionModel?.sourceCode || "",
              pick_name:
                dataOrderDetail?.tblInventoryTransactionModel?.createName ||
                dataOrderDetail?.tblInventoryTransactionModel?.fromBranchName ||
                "Điều chuyển kho HACOM",
              pick_address: dataFromBranch?.pick_address,
              pick_province: pickProvinceName,
              pick_district: null,
              pick_ward: pickCommuneName,
              pick_tel: dataFromBranch?.pick_tel,
              tel: dataEmployeeManagerItem.telephoneNumber,
              name: dataEmployeeManagerItem.empName,
              address: dataToBranch?.pick_address,
              province: provinceName,
              district: null,
              ward: communeName,
              hamlet: "Khác",
              is_freeship: "1",
              pick_money: 0,
              note: "",
              value: dataSerialOnHand.reduce((sum, i) => {
                return sum + (i.poPrice || 0);
              }, 0),
              pick_option: "cod",
              total_box: totalBox || 1,
            },
          },
        },
      );

      if (responseGHTK?.success === true) {
        NotificationExtension.Success("Tạo đơn GHTK thành công");

        await repositoryMdm.post<MessageResponse<any>>(
          "/api/v1/TblRequestTransfer/update-attribute16",
          {
            id: dataOrderDetail?.tblInventoryTransactionModel?.sourceId,
            attribute16: String(responseGHTK?.order?.tracking_id),
            attribute17: "GHTK",
            attribute18: responseGHTK?.order?.label,
            attribute19: null,
            attribute20: "Đẩy đơn GHTK",
          },
        );
      } else {
        await repositoryMdm.post<MessageResponse<any>>(
          "/api/v1/TblRequestTransfer/update-attribute16",
          {
            id: dataOrderDetail?.tblInventoryTransactionModel?.sourceId,
            attribute16: `Fail: ${responseGHTK?.message}`,
          },
        );
        NotificationExtension.Fails(
          `Lỗi đẩy đơn GHTK: ${responseGHTK?.message}` ||
            "Lỗi đẩy đơn GHTK: Đăng đơn lên GHTK thất bại !",
        );
      }
    } else {
      return;
    }
  };

  const createAhamoveOrderStg = async (data: any) => {
    try {
      const response = await axios.post(
        "https://partner-apistg.ahamove.com/v3/orders",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0eXAiOiJ1c2VyIiwiY2lkIjoiODQ5NjQ2MzUxMzYiLCJzdGF0dXMiOiJPTkxJTkUiLCJlb2MiOiJ2YW52aW5oc3B1ckBnbWFpbC5jb20iLCJub2MiOiJDw7RuZyB0eSBD4buVIHBo4bqnbiDEkOG6p3UgdMawIEPDtG5nIG5naOG7hyBIQUNPTSBBZG1pbiIsImN0eSI6IlNHTiIsInR5cGUiOiJhcGkiLCJwYXJ0bmVyIjoiaGFjb20iLCJleHAiOjE4MTY5NDM5MDUsImlhdCI6MTc1Mzg3MTkwNSwiaXNzIjoiYWhhIn0.fO6fONjUfp2KzIlgYX5HjeNa06UfFxa1BEVHANnrj7U", // 🔁 Thay <token> bằng token thật từ Postman
          },
        },
      );
      return response;
    } catch (error: any) {
      console.error(
        "Ahamove API error:",
        error.response?.data || error.message,
      );
      return error.response?.data || error.message;
    }
  };

  const handleOrderAhamove = async () => {
    if (dataOutWard?.tblItemTransactionHeaderCommand?.sourceType !== "XUAT_BAN")
      return;

    const url = `/api/v1/CreateSellItem/details?orderNumber=${dataOutWard?.tblItemTransactionHeaderCommand?.sourceCode}`;
    const response = await repositoryPos.get<MessageResponse<any>>(url);

    if (response && response?.success) {
      const dataWarehouse = dataMasterOrg.find(
        (i) => String(i.orgId) === String(response.data?.orderHeader?.orgId),
      );

      const customerData = JSON.parse(response.data?.orderHeader?.attribute1);

      if (response.data?.orderHeader?.shipingVendor !== "Ahamove") return;

      if (
        response.data?.orderHeader?.attribute24 === "Giao Hàng Thu Tiền(COD)" &&
        (response.data?.orderHeader.amountRemaining === 0 ||
          !response.data?.orderHeader.amountRemaining)
      ) {
        return NotificationExtension.Fails(
          "Đơn hàng này không có COD, không thể tạo đơn GHTK COD",
        );
      }

      const [provinceName, communeName] = await Promise.all([
        fetchDataProvinceNew(customerData.customerProvinceId),
        fetchDataCommuneNew(
          customerData.customerProvinceId,
          customerData.customerCommuneId,
        ),
      ]);

      if (!provinceName || String(provinceName).length === 0) {
        NotificationExtension.Fails("Tỉnh/TP không tồn tại !");
        return;
      }

      if (!communeName || String(communeName).length === 0) {
        NotificationExtension.Fails("Phường/xã không tồn tại !");
        return;
      }

      const addressAhamove = [
        customerData?.customerAddress,
        communeName,
        provinceName,
      ]
        .filter((i) => i && String(i).length > 0)
        .join(", ");

      const items = response.data?.orderDetail.map((item: any) => ({
        _id: item.itemId, // hoặc chuyển thành chuỗi: String(item.itemId)
        num: item.quality, // số lượng
        name: item.itemName, // tên sản phẩm
        price: item.priceFinal || 0, // giá (nếu không có thì để 0)
      }));
      const dataAhamove = {
        order_time: 0,
        path: [
          {
            // lat: 10.76975346,
            // lng: 106.6636615,
            address: dataWarehouse?.pick_address
              .split("-")
              .map((i: any) => i.trim())
              .join(", "),
            short_address: String(dataWarehouse?.pick_address || "")
              .toLowerCase()
              .includes("hồ chí minh")
              ? "Hồ Chí Minh"
              : "Hà Nội",
            name: "Giao vận Hacom",
            mobile: "0988655130",
            remarks: "Đến nơi lấy hàng đọc mã đơn để nhận hàng",
          },
          {
            // lat: 10.8018493,
            // lng: 106.714466,
            address: addressAhamove,
            short_address: String(addressAhamove || "")
              .toLowerCase()
              .includes("hồ chí minh")
              ? "Hồ Chí Minh"
              : "Hà Nội",
            name: customerData.customerName,
            mobile: customerData.telephoneNumber,
            cod:
              response.data?.orderHeader?.attribute24 ===
              "Giao Hàng Thu Tiền(COD)"
                ? (response.data?.orderHeader.amountRemaining || 0) -
                  (response.data?.orderHeader.deposit || 0)
                : 0,
            item_value: response.data?.orderHeader.amountTotal,
            tracking_number: response.data?.orderHeader.orderNumber,
            remarks: "Gọi điện trước khi giao. Giao hàng cẩn thận",
          },
        ],
        service_id:
          customerData?.typeShip === "Siêu tốc"
            ? String(dataWarehouse?.pick_address || "")
                .toLowerCase()
                .includes("hồ chí minh")
              ? "SGN-BIKE"
              : "HAN-BIKE"
            : customerData?.typeShip === "Siêu tốc tiết kiệm"
              ? String(dataWarehouse?.pick_address || "")
                  .toLowerCase()
                  .includes("hồ chí minh")
                ? "SGN-ECO"
                : "HAN-ECO"
              : String(dataWarehouse?.pick_address || "")
                    .toLowerCase()
                    .includes("hồ chí minh")
                ? "SGN-SAMEPRICE"
                : "HAN-SAMEPRICE", // Đồng giá 25k
        // requests: [
        //   {
        //     _id:
        //       customerData?.typeShip === "Siêu tốc"
        //         ? "HAN-BIKE-TRANSFER-COD"
        //         : customerData?.typeShip === "Siêu tốc tiết kiệm"
        //           ? "HAN-ECO-TRANSFER-COD"
        //           : "HAN-SAMEPRICE-TRANSFER-COD", // Đồng giá 25k
        //   },
        // ],
        payment_method: "CASH",
        remarks:
          "Tài xê không cần gọi shop , vào trực tiếp của hàng , đọc mã đơn cho bộ phận kho để lấy hàng",
        items: items,
        // package_detail: [
        //   {
        //     weight: 10,
        //     length: 1.2,
        //     width: 0.8,
        //     height: 2.0,
        //     description: "Linh kiện máy tính",
        //   },
        // ],
      };
      const responseAhamove = await createAhamoveOrderStg(dataAhamove);
      if (responseAhamove?.data?.order_id) {
        // Parse attribute1 từ JSON sang object
        const currentAttribute1 = JSON.parse(
          response.data?.orderHeader?.attribute1 || "{}",
        );

        // Thêm sharedLink vào object
        const updatedAttribute1 = {
          ...currentAttribute1,
          sharedLink: responseAhamove?.data?.shared_link,
        };

        // Chuyển lại thành JSON và lưu vào database
        await repositoryPos.post("/api/v1/CreateSellItem/update-attribute1", {
          orderNumber: response.data?.orderHeader?.orderNumber,
          attribute1: JSON.stringify(updatedAttribute1),
        });

        setTimeout(() => {
          NotificationExtension.Success("Tạo đơn Ahamove thành công");
        }, 1000); // Delay 200ms
      } else {
        setTimeout(() => {
          NotificationExtension.Fails(
            `Tạo đơn Ahamove thất bại: ${responseAhamove?.description}`,
          );
        }, 1000); // Delay 200ms

        // Ghi log lỗi vào hệ thống
        await repositoryPos.post("/api/v1/CreateSellItem/update-ghtk-log", {
          orderNumber: response.data?.orderHeader?.orderNumber,
          attribute42:
            responseAhamove?.description ||
            "Lỗi không xác định khi tạo đơn Ahamove",
        });
      }
    }
  };

  const handleOrderGrabExpress = async () => {
    debugger;
    console.log(
      "[GrabExpress] handleOrderGrabExpress triggered",
      dataOutWard?.tblItemTransactionHeaderCommand,
    );
    if (
      dataOutWard?.tblItemTransactionHeaderCommand?.sourceType !== "XUAT_BAN"
    ) {
      console.log(
        "[GrabExpress] Exit: sourceType is not XUAT_BAN",
        dataOutWard?.tblItemTransactionHeaderCommand?.sourceType,
      );
      return;
    }

    const url = `/api/v1/CreateSellItem/details?orderNumber=${dataOutWard?.tblItemTransactionHeaderCommand?.sourceCode}`;
    const response = await repositoryPos.get<MessageResponse<any>>(url);
    console.log("[GrabExpress] response details:", response);

    if (response && response?.success) {
      const dataWarehouse = dataMasterOrg.find(
        (i) => String(i.orgId) === String(response.data?.orderHeader?.orgId),
      );

      const customerData = JSON.parse(response.data?.orderHeader?.attribute1);

      console.log(
        "[GrabExpress] shipingVendor:",
        response.data?.orderHeader?.shipingVendor,
      );

      if (response.data?.orderHeader?.shipingVendor !== "Grab") {
        console.log("[GrabExpress] Exit: shipingVendor is not Grab");
        return;
      }

      const [provinceName, communeName] = await Promise.all([
        fetchDataProvinceNew(customerData.customerProvinceId),
        fetchDataCommuneNew(
          customerData.customerProvinceId,
          customerData.customerCommuneId,
        ),
      ]);

      if (!provinceName || String(provinceName).length === 0) {
        NotificationExtension.Fails("Tỉnh/TP không tồn tại !");
        return;
      }

      if (!communeName || String(communeName).length === 0) {
        NotificationExtension.Fails("Phường/xã không tồn tại !");
        return;
      }

      const addressDelivery = [
        customerData?.customerAddress,
        communeName,
        provinceName,
      ]
        .filter((i) => i && String(i).length > 0)
        .join(", ");

      const packages = response.data?.orderDetail.map((item: any) => ({
        name: item.itemName,
        description: "Hàng hóa xuất kho",
        quantity: item.quality,
        price: item.priceFinal || 0,
        dimensions: { height: 10, width: 30, depth: 40, weight: 2500 }, // Dummy values required by grab
      }));

      const defaultLat = String(provinceName)
        .toLowerCase()
        .includes("hồ chí minh")
        ? 10.8231
        : 21.0285;
      const defaultLng = String(provinceName)
        .toLowerCase()
        .includes("hồ chí minh")
        ? 106.6297
        : 105.8542;

      const dataGrab = {
        merchantOrderID: response.data?.orderHeader?.orderNumber,
        serviceType: "INSTANT",
        paymentMethod: "CASH",
        sender: {
          firstName: "Hacom",
          lastName: "Store",
          phone: dataWarehouse?.pick_tel || "0988655130",
        },
        recipient: {
          firstName: customerData.customerName || "Khách hàng",
          lastName: "", // Grab requires string but we might not have a split last name
          phone: customerData.telephoneNumber,
        },
        origin: {
          address: dataWarehouse?.pick_address || "Cửa hàng Hacom",
          coordinates: { latitude: defaultLat, longitude: defaultLng },
        },
        destination: {
          address: addressDelivery,
          coordinates: {
            latitude: defaultLat + 0.01,
            longitude: defaultLng + 0.01,
          },
        },
        packages: packages,
      };

      const responseGrab = await createGrabExpressDelivery(dataGrab);
      if (responseGrab && responseGrab.deliveryID) {
        console.log("responseGrab", responseGrab);

        // Parse attribute1 từ JSON sang object
        const currentAttribute1 = JSON.parse(
          response.data?.orderHeader?.attribute1 || "{}",
        );

        // Thêm grabDeliveryId vào object
        const updatedAttribute1 = {
          ...currentAttribute1,
          grabDeliveryId: responseGrab.deliveryID,
        };

        // Chuyển lại thành JSON và lưu vào database
        await repositoryPos.post("/api/v1/CreateSellItem/update-attribute1", {
          orderNumber: response.data?.orderHeader?.orderNumber,
          attribute1: JSON.stringify(updatedAttribute1),
        });

        setTimeout(() => {
          NotificationExtension.Success("Tạo đơn GrabExpress thành công");
        }, 1000); // Delay 200ms
      } else {
        setTimeout(() => {
          NotificationExtension.Fails(
            `Tạo đơn GrabExpress thất bại: ${responseGrab?.message || responseGrab?.error || "Lỗi không xác định"}`,
          );
        }, 1000); // Delay 200ms

        // Ghi log lỗi vào hệ thống
        await repositoryPos.post("/api/v1/CreateSellItem/update-ghtk-log", {
          orderNumber: response.data?.orderHeader?.orderNumber,
          attribute42:
            responseGrab?.message ||
            responseGrab?.error ||
            "Lỗi không xác định khi tạo đơn GrabExpress",
        });
      }
    }
  };

  const handleSendMessageOrderSuccsess = async () => {
    const listBranchRes = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmInventory/get-select-branch?auth=false",
    );
    const branchIdToCheck =
      dataOrderDetail?.tblInventoryTransactionModel?.fromBranchId ||
      dataOutWard?.tblItemTransactionHeaderCommand?.branchId;
    const isDVT =
      listBranchRes?.data?.find(
        (item: any) => Number(item.value) === Number(branchIdToCheck),
      )?.attr6 === "DVT";
    console.log(
      "[DVT-DEBUG] WarehouseOutWard handleSendMessage - isDVT:",
      isDVT,
      "| branchId:",
      branchIdToCheck,
    );
    if (isDVT) return;
    const url = `/api/v1/CreateSellItem/details?orderNumber=${dataOutWard?.tblItemTransactionHeaderCommand?.sourceCode}`;
    const responseOrder = await repositoryPos.get<MessageResponse<any>>(url);

    if (responseOrder && responseOrder?.success) {
      const orderHeaderData = responseOrder?.data?.orderHeader;
      let customerData: any = {};

      try {
        customerData = JSON.parse(orderHeaderData?.attribute1 || "{}");
      } catch (error) {
        console.error("Error parsing delivery data from attribute1:", error);
      }

      const customerResponse = await repositoryPos.get<MessageResponse<any>>(
        `/api/v1/TblDmCustomer/get-detail?id=${orderHeaderData?.custId}`,
      );
      const customer = customerResponse?.data;

      if (customer?.groupId === 166) return;
      if (customer?.type !== 1 && customer?.type !== 2) return; // Cho phép cả công ty nếu có SĐT
      if (
        customer?.groupCode === "PHUQUYHY_CAM" ||
        customer?.groupCode === "CAM"
      )
        return;

      const recipientPhone =
        customerData?.telephoneNumber || customer?.telephoneNumber;
      if (!recipientPhone) return;

      const deliveryAppointment = moment(customerData?.deliveryAppointmentTime);

      const isNoShipping = orderHeaderData?.shipngType === "Nhận tại cửa hàng";

      const expectedDeliveryDate = isNoShipping
        ? moment().format("DD/MM/YYYY")
        : customerData?.deliveryAppointmentTime && deliveryAppointment.isValid()
          ? deliveryAppointment.format("DD/MM/YYYY")
          : "Chưa xác định";

      const znsResponse = await sendZnsMessage(
        createZnsPayload(
          `${orderHeaderData?.orderNumber || "OUTWARD"}-${Date.now()}`,
          ZNS_TEMPLATE_IDS.ORDER_OUTWARD,
          {
            customer_name:
              customer?.name || customerData?.customerName || "Khách hàng",
            ma_don_hang: orderHeaderData?.orderNumber,
            thoi_diem_xuat_kho: moment().format("DD/MM/YYYY HH:mm"),
            ngay_nhan_du_kien: expectedDeliveryDate,
          },
          recipientPhone,
        ),
      );

      if (znsResponse?.status === 0 || znsResponse?.success === false) {
        NotificationExtension.Fails(
          znsResponse?.description ||
            znsResponse?.message ||
            "Gui ZNS that bai",
        );
      }

      return;

      const response: any = await repositoryMdm.post<MessageResponse<any[]>>(
        `/api/v1/CareSoft/create-deal`,

        {
          deal: {
            phone: customerData?.telephoneNumber,
            subject: "Hacom - OA",
            estimated_closed_date: "2024/03/21 23:59:59",
            comment: {
              body: "Cập nhật thông tin xuất kho",
              is_public: 1,
              author_id: orderHeaderData?.attribute50,
            },
            pipeline_id: 202,
            pipeline_stage_id: 1551,
            assignee_id: orderHeaderData?.attribute50, // ID người phụ trách tạo đơn
            custom_fields: [
              { id: "11363", value: orderHeaderData?.orderNumber }, // Số đơn hàng
              // { id: "11383", value: formattedDate }, // ngày nhận hàng dự kiến
              // { id: "11364", value: payLatter > 0 ? "165936" : "165935" }, //Đã thanh toán: 165935 Chưa thanh toán: 165936 Cọc: 165937
              // {
              //   id: "11362",
              //   value: formatDateStringCareSoft(orderHeaderData?.createDate),
              // }, // ngày tạo đơn
              // { id: "11365", value: customerData?.address }, // Địa chỉ khách hàng
              // Trạng thái giao hàng
              // Đơn hàng bị Huỷ: 167208
              // Đơn hàng giao trễ: 167209
              // Đơn hàng đã xuất kho: 167210
              // Giao thành công: 167211
              { id: "11398", value: "167210" },
              { id: "11384", value: moment().format("DD/MM/YY") }, // Thời điểm xuất kho - Text
              { id: "11385", value: "0988655130" }, //Thông tin nhân viên giao - text
              {
                id: "11386",
                value: (customerData.cod || 0).toLocaleString("vi-VN"),
              }, // Số tiền thanh toán còn lại
            ],
          },
          token: "1FRvLEuRQgf5gdE",
          careSoftId: orderHeaderData?.attribute40,
        },
      );

      if (response && response.success) {
        let result = response.data;
      }
    }
  };

  console.log("dataOutWard", dataOutWard);
  console.log("dataOrderDetail", dataOrderDetail);

  const handleCreateOutWard = async (
    status: string,
    isLocked?: boolean,
    totalBox?: number,
    products?: any[],
  ) => {
    const getTotalQuantity = (key: string) =>
      dataOrderDetail?.inventoryTransactionRequestSourceModels?.reduce(
        (total, item: any) => total + (item[key] || 0),
        0,
      );
    if (
      dataOutWard.tblItemTransactionHeaderCommand.sourceType ===
      "XUAT_DOI_LINH_KIEN"
    ) {
      if (dataOutWard.tblItemTransactionHeaderCommand.atribute10 === null) {
        NotificationExtension.Fails("Vui lòng chọn vị trí");
        return;
      }
    }
    if (
      dataOutWard.tblItemTransactionHeaderCommand.sourceType ===
      "XUAT_DIEU_CHUYEN_LINH_KIEN_SAN_XUAT"
    ) {
      if (dataOutWard.tblItemTransactionHeaderCommand.atribute10 === null) {
        NotificationExtension.Fails("Vui lòng chọn vị trí");
        return;
      }
    }

    const totalPrimaryQuantity = getTotalQuantity("primaryQuantity");
    const totalLimitQuantity = getTotalQuantity("limitQuantity");

    const checkTotalPrimary = totalPrimaryQuantity === dataSerialOnHand?.length;
    const checkTotalQuantity = totalLimitQuantity === dataSerialOnHand?.length;

    const _sourceType =
      dataOutWard?.tblItemTransactionHeaderCommand?.sourceType || sourceType;

    const validationErrors = [
      {
        condition: dataSerialOnHand.some((item) => item.warning),
        message: "Có sản phẩm không hợp lệ",
      },
      {
        condition: isExceedQuantity,
        message: "Có sản phẩm vượt quá số lượng cần xuất",
      },
      {
        condition:
          _sourceType === "XUAT_DIEU_CHUYEN_LINH_KIEN_SAN_XUAT" &&
          !checkTotalPrimary,
        message: "Vui lòng nhập đủ linh kiện",
      },
      {
        condition:
          _sourceType === "XUAT_LINH_KIEN_SAN_XUAT" && !checkTotalQuantity,
        message: "Vui lòng nhập đủ linh kiện",
      },
      {
        condition:
          dataOutWard?.tblItemTransactionHeaderCommand?.description &&
          dataOutWard?.tblItemTransactionHeaderCommand?.description?.length >
            300,
        message: "Ghi chú phiếu xuất không quá 300 ký tự",
      },
      {
        condition:
          _sourceType === "XUAT_LINH_KIEN_SAN_XUAT" &&
          !dataOutWard?.tblItemTransactionHeaderCommand?.parentSerial,
        message: "Vui lòng nhập mã serial",
      },
    ];

    // Kiểm tra lỗi và thông báo
    for (const { condition, message } of validationErrors) {
      if (condition) {
        NotificationExtension.Fails(message);
        return;
      }
    }

    // Với xuất hồi linh kiện sản xuất: nếu có sản phẩm bị lệch (scannedQuantity - primaryQuantity !== 0)
    // thì không cho hoàn thành (khóa) phiếu
    if (_sourceType === "XUAT_HOI_LINH_KIEN_SAN_XUAT" && status === "LOCK") {
      const varianceReturn = checkVarianceItem(
        dataOrderDetail?.inventoryTransactionRequestSourceModels,
        "primaryQuantity",
      );
      if (varianceReturn.isVariance) {
        NotificationExtension.Fails(
          "Có sản phẩm bị lệch số lượng, vui lòng kiểm tra lại trước khi hoàn thành",
        );
        handleChangeValueInput("OPEN", "status");
        return;
      }
    }

    if (dataSerialOnHand.length > 5000) {
      NotificationExtension.Warn(
        "Số lượng serial vượt quá 5000, vui lòng kiểm tra lại",
      );
      return;
    }
    // Reset key search và thay đổi trạng thái
    setKeySearch("");
    handleChangeValueInput(status, "status");

    // Chuẩn bị dữ liệu tạo phiếu
    const serials = dataSerialOnHand?.map((item) => ({
      primaryQuantity: item.primaryQuantity,
      // primaryQuantity: 1,
      subQuantity: item.subQuantity,
      serial: item.serial,
      invId:
        dataOrderDetail?.tblInventoryTransactionModel?.fromInvId ?? item.invId,
      note: item.note,
      locatorId: Number(item.locatorId) || item.positionId,
    }));

    const attributes = getAttributes(
      dataOutWard.tblItemTransactionHeaderCommand.sourceType,
    );
    const dataCreate = {
      ...dataOutWard,
      tblItemTransactionHeaderCommand: {
        ...dataOutWard.tblItemTransactionHeaderCommand,
        branchId: dataOrderDetail?.tblInventoryTransactionModel?.fromBranchId,
        subInvId:
          dataOrderDetail?.tblInventoryTransactionModel?.fromInvId ?? 6014,
        status,
        description: dataOutWard.tblItemTransactionHeaderCommand.description,
        parentSerial:
          dataOutWard?.tblItemTransactionHeaderCommand?.parentSerial,
        transactionId:
          transitionSaveId ||
          dataOutWard.tblItemTransactionHeaderCommand.transactionId,
        attribute11:
          dataOutWard?.tblItemTransactionHeaderCommand?.attribute11?.toString() ??
          "",
        attribute12:
          dataOutWard?.tblItemTransactionHeaderCommand?.attribute12?.toString() ??
          "",
        fromPositionId:
          dataOutWard?.tblItemTransactionHeaderCommand?.fromPositionId,
        ...attributes,
        ecommerceOrderId:
          dataOrderDetail?.tblInventoryTransactionModel?.ecommerceOrderId,
      },
      serials,
      isLock: isLocked,
    };

    const url = getOutwardApiUrl(
      "create",
      dataOutWard.tblItemTransactionHeaderCommand.sourceType,
    );

    try {
      const checkQuantityBy =
        _sourceType === "XUAT_LINH_KIEN_SAN_XUAT"
          ? "limitQuantity"
          : "primaryQuantity";
      const variance = checkVarianceItem(
        dataOrderDetail?.inventoryTransactionRequestSourceModels,
        checkQuantityBy,
      );

      if (variance.isVariance) {
        const confirm = await openCofirmModal(
          variance.varianceItems,
          status === "LOCK",
        );
        if (!confirm) {
          handleChangeValueInput("OPEN", "status");
          return;
        }
      }
      // Xử lý khi trạng thái là "LOCK"
      if (status === "LOCK") {
        setIsLoading(true);
        const fromInvCode =
          dataOrderDetail?.tblInventoryTransactionModel?.fromInvCode;
        const shouldCheckFIFO =
          fromInvCode?.includes("HB") || fromInvCode?.includes("SR");
        // Hàm check nếu phiếu xuất bán thì check FIFO
        //Nguyên tắc FIFO (First In, First Out - Nhập trước, Xuất trước) là phương pháp quản
        // lý hàng tồn kho, trong đó hàng hóa/nguyên liệu được nhập vào kho trước sẽ được ưu tiên
        //  xuất ra, sử dụng hoặc bán trước.
        if (shouldCheckFIFO) {
          const canProceed = await handleWaningFIFO(
            serials,
            dataCreate.tblItemTransactionHeaderCommand.branchId,
            dataCreate.tblItemTransactionHeaderCommand.subInvId,
          );
          if (!canProceed) {
            console.log(
              "Logz chạy vào đây khi người dùng bấm HỦY sau khi check FIFO",
            );
            setIsLoading(false);
            return;
          }
          console.log(
            "Logz chạy vào đây khi người dùng bấm TIẾP TỤC sau khi check FIFO",
          );
        } else {
          console.log(
            "Logz chạy vào đây khi người dùng bấm TIẾP TỤC sau khi check FIFO",
          );
        }

        const lockResponse = await postOutwardRequest(url, dataCreate);
        if (lockResponse?.success) {
          // await handleSwitchToKTKT(lockResponse.data);
          handeOrderGHTK(totalBox, products);
          handleOrderAhamove();
          handleOrderGrabExpress();
          if (_sourceType === "XUAT_BAN") {
            await handleSendMessageOrderSuccsess();
          }
          // await handleSwitchToKTKT(lockResponse.data);
          handleChangeValueInput("LOCK", "status");
          handleChangeValueInput(Date().toString(), "finishDate");
          setIsLoading(true);
          NotificationExtension.Success("Khóa phiếu xuất kho thành công");
          if (
            [
              "XUAT_LINH_KIEN_SAN_XUAT",
              "XUAT_DIEU_CHUYEN_LINH_KIEN_SAN_XUAT",
            ].includes(changeSourceType ?? "")
          ) {
            setTimeout(() => navigate("/warehouse-config/wip"), 3000);
          }
          if (
            _sourceType === "XUAT_BAN" ||
            _sourceType === "XUAT_DOI_TRA" ||
            _sourceType === "XUAT_DIEU_CHUYEN_CHI_NHANH_SERIAL" ||
            _sourceType === "XUAT_DIEU_CHUYEN_CHI_NHANH" ||
            _sourceType === "XUAT_TRA_NCC"
          ) {
            setIdPrintCreate(Number(lockResponse.data));
            // setTimeout(
            //   () =>
            //     onhandlePrint(
            //       lockResponse.data,
            //       dataCreate.tblItemTransactionHeaderCommand.sourceType
            //     ),
            //   1000
            // );
          }
        } else {
          handleChangeValueInput("", "status");
        }
        return;
      } else if (status === "OPEN") {
        const fromInvCode =
          dataOrderDetail?.tblInventoryTransactionModel?.fromInvCode;
        const shouldCheckFIFO =
          fromInvCode?.includes("HB") || fromInvCode?.includes("SR");
        // Hàm check nếu phiếu xuất bán thì check FIF
        if (shouldCheckFIFO) {
          const canProceed = await handleWaningFIFO(
            serials,
            dataCreate.tblItemTransactionHeaderCommand.branchId,
            dataCreate.tblItemTransactionHeaderCommand.subInvId,
          );
          if (!canProceed) {
            console.log(
              "Logz chạy vào đây khi người dùng bấm HỦY sau khi check FIFO",
            );
            setIsLoading(false);
            return;
          }
          console.log(
            "Logz chạy vào đây khi người dùng bấm TIẾP TỤC sau khi check FIFO",
          );
        }

        const response = await postOutwardRequest(url, dataCreate);
        if (response && status === "OPEN") {
          handleChangeValueInput("OPEN", "status");
          setTransactionTempId(response?.data?.data);
          setTransitionSaveId(response.data);
          NotificationExtension.Success("Lưu phiếu xuất kho thành công");
        }
        // Xử lý khi trạng thái là "OPEN"
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  // phiếu cần xuất , khi người ta nhấn hoàn thành đơn
  const handleWaningFIFO = async (
    serials: any,
    branchId: number,
    subInvId: number,
  ): Promise<boolean> => {
    try {
      const response = await repositoryPos.post(
        "/api/v1/TblInventorySerialOnHand/check-fifo",
        {
          listSerial: serials?.map((item: any) => item.serial),
          branchId: branchId,
          subInvId: subInvId,
        },
      );

      if (response && response.success === false) {
        return new Promise((resolve) => {
          modals.open({
            title: (
              <Text fw={700} size="lg">
                Cảnh báo Nhập trước Xuất trước (Cảnh báo FIFO)
              </Text>
            ),
            children: (
              <FifoWarningModal
                data={response.data}
                onConfirm={() => {
                  modals.closeAll();
                  resolve(true);
                }}
                onCancel={() => {
                  modals.closeAll();
                  handleChangeValueInput("", "status");
                  resolve(false);
                }}
              />
            ),
            size: "xl",
            withCloseButton: false,
            closeOnClickOutside: false,
          });
        });
      }
      return true;
    } catch (error) {
      console.error(error);
      return true;
    }
  };

  const handleSwitchToKTKT = async (idCreate: any) => {
    const response = await repositoryDelivery.post(
      "api/v1/TblTestingTechniqueHeader/create-from-transaction",
      {
        transactionId: idCreate,
      },
    );
    if (response?.httpStatusCode === 200 && response?.success) {
      return response;
    } else {
      return null;
    }
  };
  //#region In bắt đầu
  const openOptionPrintHandover = (id: number, type: string) => {
    setOpenPrintHandover(true);
    modals.openConfirmModal({
      title: "Nhập thông tin",
      closeOnConfirm: false,
      size: "550px",
      children: (
        <OptionPrintHandover
          id={id}
          type={type}
          onhandlePrint={onhandlePrint}
          setValuePrintHandoverModal={setValuePrintHandoverModal}
        />
      ),
      style: {
        height: "auto",
      },
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  const openPrintOptionModal = (id: number, type: string) => {
    setOpenPrintHandover(false);
    modals.openConfirmModal({
      title: "Chọn loại phiếu Xuất Kho Bán",
      closeOnConfirm: false,
      size: "400px",
      children: (
        <OptionPrintOutWard
          id={id}
          type={type}
          onhandlePrint={onhandlePrint}
          setValuePrintOptionModal={setValuePrintOptionModal}
          isTMDT={
            changeSourceType === "XUAT_BAN" &&
            dataOutWard.tblItemTransactionHeaderCommand?.ecommerceOrderId ? (
              <>
                <PrintTheTMDT
                  // pdfUrl="https://content.pancake.vn/2-2510/2025/10/9/c15f1873900ab5324d1024821c77663a7418215c.c15f1873900ab5324d1024821c77663a7418215c"
                  autoPrint={false}
                  idPrintCreate={
                    dataOutWard.tblItemTransactionHeaderCommand.ecommerceOrderId
                  }
                />
              </>
            ) : (
              <></>
            )
          }
          isTmdtOrder={
            changeSourceType === "XUAT_BAN" &&
            !!dataOutWard.tblItemTransactionHeaderCommand?.ecommerceOrderId
          }
          setDataLinhKienLR={setDataLinhKienLR}
          seriaLinhKienLR={dataSerialOnHand}
          location={location}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  const handleDownLoadWord = () => {
    fetch("/Bien-ban-ban-giao-va-nghiem-thu-hang-hoa.docx").then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "Bien-ban-ban-giao-va-nghiem-thu-hang-hoa.docx";
        a.click();
      });
    });
  };

  const onhandlePrint = (
    id: string | number,
    type: string | null,
    printOption?: {
      option1: string;
      option2: string;
      dichVuDiKem: boolean;
      inLinhKienLR: boolean;
      inQR: boolean;
    },
  ) => {
    if (id != null && type != null) {
      // Ghi ngay vào ref (synchronous, không bị ảnh hưởng bởi React batching)
      shouldPrintQrRef.current = !!printOption?.inQR;
      if (printOption) {
        setValuePrintOptionModal(printOption);
      }
      setIdPrint(id);
      setTypePrint(type);
    }
  };

  const parseMoneyValue = React.useCallback((value: any): number => {
    if (typeof value === "number" && Number.isFinite(value)) {
      return value;
    }

    if (value == null) {
      return 0;
    }

    // Keep digits only to avoid NaN when backend returns formatted strings like 779,995 or 779.995
    const cleaned = String(value).replace(/[^\d-]/g, "");
    const parsed = Number(cleaned);
    return Number.isFinite(parsed) ? parsed : 0;
  }, []);

  const getTotalAmountForQR = React.useCallback(
    (printData: any) => {
      const transaction = printData?.tblInventoryTransactionModel;
      const serials = printData?.inventoryTransactionSerialModels || [];

      const codAmount = parseMoneyValue(transaction?.codAmount);
      if (codAmount > 0) {
        return codAmount;
      }

      return serials.reduce((total: number, item: any) => {
        const price =
          transaction?.sourceType === "XUAT_TRA_NCC"
            ? parseMoneyValue(item?.poPrice)
            : parseMoneyValue(item?.soPrice);
        const quantity = parseMoneyValue(item?.primaryQuantity);

        return Number(total) + (price && quantity ? price * quantity : 0);
      }, 0);
    },
    [parseMoneyValue],
  );

  const handleCreateQrCode = async (amount: number, orderNumber: string) => {
    const listBranchRes = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmInventory/get-select-branch?auth=false",
    );
    const branchIdToCheck =
      dataOrderDetail?.tblInventoryTransactionModel?.fromBranchId ||
      dataOutWard?.tblItemTransactionHeaderCommand?.branchId;
    const isDVT =
      listBranchRes?.data?.find(
        (item: any) => Number(item.value) === Number(branchIdToCheck),
      )?.attr6 === "DVT";
    console.log(
      "[DVT-DEBUG] WarehouseOutWard handleCreateQrCode - isDVT:",
      isDVT,
      "| branchId:",
      branchIdToCheck,
    );
    if (isDVT) {
      setValueQRCode("DVT_STATIC_QR");
      return "DVT_STATIC_QR";
    }
    try {
      const responseIp =
        await repositoryPos.get<MessageResponse<any>>(`/api/v1/Public/ip`);
      const ipAddress = responseIp?.data || "";

      const responseQr = await repositoryPayment.post<MessageResponse<any>>(
        `/api/TblMBQRcode/gen-qr-mb-v2`,
        {
          amount,
          ipAddress,
          orderInfo: orderNumber,
          orderNumber,
        },
      );

      if (responseQr?.success && responseQr?.data?.qr_url) {
        setValueQRCode(responseQr.data.qr_url);
        return responseQr.data.qr_url as string;
      } else {
        setValueQRCode(null);
        return null;
      }
    } catch (error) {
      console.log("error create qr", error);
      setValueQRCode(null);
      return null;
    }
  };

  const fetchDataToPrint = async (id: number | string, type: string | null) => {
    let apiPath;
    switch (type) {
      case "XUAT_BAN":
        const isDichVu = valuePrintOptionModal?.dichVuDiKem;

        apiPath = isDichVu
          ? `/api/v1/Outward/print-sale-order-out-ward?id=${id}&isserive=true`
          : `/api/v1/Outward/print-sale-order-out-ward?id=${id}`;
        break;
      case "XUAT_DOI_TRA":
        apiPath = `/api/v1/Outward/print-sale-order-out-ward?id=${id}`;
        break;
      case "XUAT_TRA_NCC":
        apiPath = `/api/v1/Outward/print-request-vendor-return-outward?id=${id}`;
        break;
      case "XUAT_CONG_CU_DUNG_CU":
        apiPath = `/api/v1/Outward/print-request-vendor-return-outward?id=${id}`;
        break;
      case "XUAT_KHAC":
        apiPath = `/api/v1/Outward/print-request-vendor-return-outward?id=${id}`;
        break;
      case "XUAT_HUY":
        apiPath = `/api/v1/Outward/print-request-cancellation-outward?id=${id}`;
        break;
      case "XUAT_DIEU_CHINH":
        apiPath = `/api/v1/Outward/print-request-adjustment-outward?id=${id}`;
        break;
      case "XUAT_DIEU_CHUYEN_CHI_NHANH":
        apiPath = `/api/v1/Outward/print-request-transfer-outward?id=${id}`;
        break;
      case "XUAT_DIEU_CHUYEN_NOI_BO":
        apiPath = `/api/v1/Outward/print-request-transfer-internal-outward?id=${id}`;
        break;
      case "XUAT_DIEU_CHUYEN_NOI_BO_SERIAL":
        apiPath = `/api/v1/Outward/print-request-transfer-internal-outward?id=${id}`;
        break;
      // case "XUAT_DIEU_CHUYEN_CHI_NHANH_SERIAL":
      //   apiPath = `/api/v1/Outward/print-request-transfer-serial-outward?id=${id}`;
      //   break;
      case "XUAT_DIEU_CHUYEN_CHI_NHANH_SERIAL":
        apiPath = `/api/v1/Outward/print-request-transfer-outward?id=${id}`;
        break;
      case "XUAT_LINH_KIEN_SAN_XUAT":
        apiPath = `/api/v1/Outward/print-production-order-outward?id=${id}`;
        break;
      default:
        return;
    }
    try {
      const response = await repositoryPos.get<MessageResponse<any>>(apiPath);
      if (response?.success && response?.data) {
        if (
          response?.data?.tblInventoryTransactionModel.dvtn !== null &&
          response?.data?.tblInventoryTransactionModel?.gv !==
            "Nhận tại cửa hàng"
        ) {
          const dataViewLocation = JSON.parse(
            response?.data?.tblInventoryTransactionModel?.attribute3 || "{}",
          );
          if (dataViewLocation) {
            updateLocationData(
              "customerAddress",
              dataViewLocation?.customerAddress,
            );
            updateLocationData("customerName", dataViewLocation?.customerName);
            updateLocationData(
              "telephoneNumber",
              dataViewLocation?.telephoneNumber,
            );
          }
          setDataPrint(response?.data);
        } else {
          setDataPrint(response?.data);
        }

        // Fetch payment summary khi XUAT_BAN
        if (type === "XUAT_BAN") {
          try {
            const transaction = response?.data?.tblInventoryTransactionModel;
            const orderId = transaction?.sourceId; // id của đơn hàng
            if (orderId) {
              const mdmResp = await repositoryMdm.get<MessageResponse<any[]>>(
                `/api/v1/TblOrderHeader/print-order?ids=${orderId}`,
              );
              console.log("[PaymentSummary] MDM resp:", mdmResp);
              if (mdmResp?.success && mdmResp?.data?.[0]) {
                const od = mdmResp.data[0];
                setPaymentSummaryForPrint({
                  cashAmount: od?.cashAmount,
                  transferAmount: od?.custTransferTotal,
                  cardAmount: od?.cardAmount,
                  totalPayBefore: od?.payAmount,
                  codAmount: od?.codAmount,
                  payLaterMethod: od?.attribute20,
                });
              } else {
                setPaymentSummaryForPrint(null);
              }
            } else {
              console.warn(
                "[PaymentSummary] Không tìm được orderId (sourceId) từ transaction",
              );
              setPaymentSummaryForPrint(null);
            }
          } catch (e) {
            console.log("error fetch payment summary for warehouse print", e);
            setPaymentSummaryForPrint(null);
          }
        } else {
          setPaymentSummaryForPrint(null);
        }

        // console.log("dataprint", response?.data);
      } else {
        setDataPrint(null);
        NotificationExtension.Fails("error fetch data to print");
      }
    } catch (error) {
      console.log("error fetch data to print", error);
    }
  };
  const updateLocationData = (
    key:
      | "provinceName"
      | "districtName"
      | "wardName"
      | "customerAddress"
      | "customerName"
      | "telephoneNumber",
    data: any,
  ) => {
    setLocationData((prev) => ({
      ...prev,
      [key]: data,
    }));
  };
  useEffect(() => {
    if (idPrint !== "") {
      fetchDataToPrint(idPrint, typePrint);
    }
  }, [idPrint]);
  useEffect(() => {
    if (dataPrint && idPrint) {
      let idCheck: string | undefined = undefined;
      let paramType: "Ids" | "OldCommuneId" | undefined = undefined;
      const checkDvtn = dataPrint?.tblInventoryTransactionModel.dvtn;
      // Parse lại attribute3 từ dataPrint
      let parsedData: OrderDetail | null = null;
      try {
        parsedData = dataPrint?.tblInventoryTransactionModel?.attribute3
          ? JSON.parse(dataPrint.tblInventoryTransactionModel.attribute3)
          : null;
      } catch (error) {
        parsedData = null;
      }
      // NOTE:CHUYỂN ĐỔI LOGIC LẤY HẾT ĐỊA CHỈ MỚI LÊN CHỈ DÙNG TYPE LÀ IDS THÔI
      if (checkDvtn) {
        // nếu là đơn vị tiếp nhận thì mặc định truyền vào OldComnunedId
        idCheck = parsedData?.customerCommuneId;
        paramType = "Ids";
      } else if (
        dataPrint?.tblInventoryTransactionModel.newCommuneId &&
        !checkDvtn
      ) {
        //nếu là địa chỉ mới thì truyền vào Ids
        idCheck = dataPrint?.tblInventoryTransactionModel.newCommuneId;
        paramType = "Ids";
      } else if (
        dataPrint?.tblInventoryTransactionModel?.cusCommuneId &&
        !checkDvtn
      ) {
        //nếu là địa chỉ cũ thì truyền vào OldCommuneId
        idCheck = dataPrint?.tblInventoryTransactionModel.cusCommuneId;
        paramType = "Ids";
      }
      //  else if (
      //   checkDvtn &&
      //    dataPrint?.tblInventoryTransactionModel.newCommuneId
      // ) {
      //   // nếu là đơn vị tiếp nhận
      //   idCheck = parsedData?.customerCommuneId;
      //   paramType = "Ids";
      // }

      // Api gọi Xã Phường Mới
      const fetchDataReceiptCommuneMoi = async () => {
        if (!idCheck || !paramType) {
          setDataCommuneMoi([]);
          setIsReadyToPrint(true); // Không cần fetch, vẫn cho phép in
          return;
        } else {
          const response = await repositoryMdm.get<
            MessageResponse<SelectListItem[]>
          >(`/api/v1/TblDmCommuneMoi/get-select?${paramType}=${idCheck}`);
          if (response && response.success) {
            setDataCommuneMoi(response.data);
            setIsReadyToPrint(true); // Đánh dấu đã fetch xong
          }
        }
      };
      setIsReadyToPrint(false); // Reset trước khi fetch
      fetchDataReceiptCommuneMoi();
    }
  }, [dataPrint, idPrint, dataOrderDetail]);

  useEffect(() => {
    if (!dataPrint) {
      setIsReadyQrPrint(false);
      return;
    }

    // Đọc từ ref thay vì state để tránh stale closure
    const shouldPrintQr = shouldPrintQrRef.current === true;

    if (!shouldPrintQr) {
      setValueQRCode(null);
      setIsReadyQrPrint(true);
      return;
    }

    const orderNumber =
      dataPrint?.tblInventoryTransactionModel?.sourceCode ||
      dataPrint?.tblInventoryTransactionModel?.transactionCode ||
      dataOutWard?.tblItemTransactionHeaderCommand?.sourceCode ||
      String(idPrint || "");
    const totalAmount = getTotalAmountForQR(dataPrint);

    setIsReadyQrPrint(false);

    const fetchQr = async () => {
      const qrValue = await handleCreateQrCode(totalAmount, orderNumber);

      if (!qrValue && qrValue !== "DVT_STATIC_QR") {
        NotificationExtension.Warn(
          "Không tạo được mã QR thanh toán cho phiếu này",
        );
      }
      setIsReadyQrPrint(true);
    };

    fetchQr();
  }, [
    dataPrint,
    valuePrintOptionModal,
    getTotalAmountForQR,
    idPrint,
    dataOutWard?.tblItemTransactionHeaderCommand?.sourceCode,
  ]);

  useEffect(() => {
    if (
      dataPrint !== null &&
      isReadyToPrint && // Đảm bảo đã fetch xong xã/phường mới
      isReadyQrPrint // Đảm bảo đã fetch xong mã QR khi có bật in QR
    ) {
      handlePrint();
      shouldPrintQrRef.current = false;
      setIdPrint("");
      setDataPrint(null);
      setValueQRCode(null);
    }
  }, [dataPrint, isReadyToPrint, isReadyQrPrint, handlePrint]);

  const handlePrintLinhKienLapRap = async (data: any) => {
    const serialSp = data?.serial || "";
    setSerialLKPrint(serialSp);
    try {
      // const response = await repositoryPos.get<MessageResponse<any>>(`/api/v1/TblItemTransaction/get-serial-parent-info?parentSerial=${serialSp}`);
      const response = await repositoryPos.post<MessageResponse<any>>(
        `/api/v1/TblItemTransaction/get-serial-parent-info`,
        {
          parentSerial: [serialSp],
        },
      );
      const raw = response?.data ?? [];
      const ordered = [...raw];
      const idx = ordered.findIndex(
        (d: any) =>
          String(d?.serial ?? "").trim() === String(serialSp ?? "").trim(),
      );
      if (idx > 0) {
        const [parentItem] = ordered.splice(idx, 1);
        ordered.unshift(parentItem); //thằng unshift dùng để chèn phần tử vào đầu mảng
      }
      setDataLinhKienLR(ordered);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    if (
      dataLinhKienLR &&
      dataLinhKienLR.length > 0 &&
      serialLKPrint &&
      serialLKPrint !== ""
    ) {
      handlePrintLK();
      setDataLinhKienLR(null);
    }
  }, [dataLinhKienLR]);

  useEffect(() => {
    const getCurrentDateFormatted = (): string => {
      const today = new Date();
      const day = today.getDate()?.toString().padStart(2, "0");
      const month = (today.getMonth() + 1)?.toString().padStart(2, "0");
      const year = today.getFullYear();

      return `${day}.${month}.${year}`;
    };
    setCurrentDate(getCurrentDateFormatted());
  }, []);
  // #endregion In kết thúc
  // console.log(
  //   "dataOutWard.tblItemTransactionHeaderCommand.status",
  //   dataOutWard.tblItemTransactionHeaderCommand.status
  // );
  // console.log("location?.state", location?.state);
  // console.log("valuePrintOptionModal", valuePrintOptionModal);
  useEffect(() => {
    const scrollableElement = document?.querySelector(
      ".scroll-container",
    ) as HTMLElement | null;

    if (scrollableElement) {
      scrollableElement.scrollTop = scrollPosition;
    }
  }, [scrollPosition]);

  const postOutwardRequest = async (url: string, dataCreate: any) => {
    const response = await repositoryPos.post<MessageResponse<any>>(
      url,
      dataCreate,
    );
    if (response?.httpStatusCode === 200 && response?.success) {
      return response;
    } else {
      return null;
    }
  };

  const fetchDataSerialOnHand = async (
    serialCode?: string,
    positionId?: number,
  ) => {
    const _sourceType =
      dataOutWard?.tblItemTransactionHeaderCommand?.sourceType || sourceType;
    let url = `?SourceCode=${
      dataOutWard.tblItemTransactionHeaderCommand?.sourceCode || sourceCode
    }&Type=${dataOutWard.tblItemTransactionHeaderCommand.sourceType}&Serial=${
      serialCode || serial
    }&InvId=${dataOutWard.tblItemTransactionHeaderCommand?.fromInvId}`;

    try {
      const response = await repositoryPos.post<
        MessageResponse<TblInventorySerialOrderDetailOnHand>
      >(`api/v1/TblItemTransaction/search-serial-item-transaction`, {
        serial: serialCode || serial,
        sourceCode:
          dataOutWard.tblItemTransactionHeaderCommand?.sourceCode || sourceCode,
        type: dataOutWard.tblItemTransactionHeaderCommand.sourceType,
        invId: dataOutWard.tblItemTransactionHeaderCommand?.fromInvId,
        branchId: 0,
        positionId: positionId,
        isNoSerial: true,
      });
      if (response && response.success) {
        const responseData = response.data;

        if (responseData.warning) {
          NotificationExtension.Fails(responseData.warning);
        } else {
          const dataDetail = {
            ...responseData,
            subInvName: responseData.invName,
            note: null,
            // primaryQuantity: responseData.primaryQuantity,
            primaryQuantity: 1,
            locatorId: responseData.positionId,
          };
          const checkData = [...dataSerialOnHand, { ...dataDetail }];
          const checkQuantityBy =
            _sourceType === "XUAT_LINH_KIEN_SAN_XUAT"
              ? "limitQuantity"
              : "primaryQuantity";
          if (checkExceedQuantityFound(checkData, checkQuantityBy)) {
            NotificationExtension.Warn(
              "Sản phẩm vượt quá số lượng cần xuất, vui lòng kiểm tra lại",
            );
          } else {
            setDataSerialOnHand((prevData) => [...prevData, { ...dataDetail }]);
            setCheckDuplicateCode((prev) => [...prev, serialCode || serial]);
            setCheckcDuplicatePositionId((prev) => [
              ...prev,
              Number(positionId),
            ]);
          }
        }
      } else {
        NotificationExtension.Fails(response?.message || "");
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
      return;
    }
    setIsError(false);
  };
  //#region import excel

  const handleFileUpload = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".xlsx, .xls";
    input.onchange = () => {
      const file = input.files?.[0];
      if (!file) {
        NotificationExtension.Warn("Không có tập tin nào được chọn");
        return;
      }
      const reader = new FileReader();
      reader.onload = (event) => {
        try {
          const binaryStr = event.target?.result;
          const loadedWorkbook = XLSX.read(binaryStr, { type: "binary" });
          const sheetNames = loadedWorkbook.SheetNames;

          setWorkbook(loadedWorkbook);
          setSheetNames(sheetNames);
          setOpenModal(true);
        } catch (err) {
          console.error(err);
          NotificationExtension.Warn("Error processing the file");
        }
      };
      reader.readAsBinaryString(file);
    };
    input.click(); //j hàm mở chọn tệp
  };

  const handleExportExcel = () => {
    if (!dataSerialOnHand || dataSerialOnHand.length === 0) {
      NotificationExtension.Fails("Không có dữ liệu để xuất!");
      return;
    }

    const headers = [
      // { header: "Số thứ tự", key: "id" },
      { header: "Mã vị trí", key: "positionCode" },
      { header: "Tên vị trí", key: "positionName" },
      { header: "Mã hàng", key: "itemCode" },
      { header: "Serial", key: "serial" },
      { header: "Tên sản phẩm", key: "itemName" },
      { header: "ĐVT1", key: "primaryUomCode" },
      { header: "SL1", key: "primaryQuantity" },
      {
        header:
          dataOutWard?.tblItemTransactionHeaderCommand?.sourceType ===
          "XUAT_BAN"
            ? "Giá bán"
            : "Giá nhập",
        key: "poPrice",
      },
      { header: "SL2", key: "subQuantity" },
      { header: "ĐVT2", key: "subUomName" },
      { header: "Thành tiền", key: "totalAmount" },
      { header: "Tình trạng", key: "status" },
      { header: "Ghi chú", key: "note" },
    ];

    const dataToExport = dataSerialOnHand.map((item) => ({
      positionCode: item.positionCode,
      positionName: item.positionName,
      itemCode: item.itemCode,
      serial: item.serial,
      itemName: item.itemName,
      primaryUomCode: item.primaryUomCode,
      primaryQuantity: item.primaryQuantity,
      poPrice:
        dataOutWard?.tblItemTransactionHeaderCommand?.sourceType === "XUAT_BAN"
          ? item.soPrice && item.soPrice?.toLocaleString()
          : item.poPrice && item.poPrice?.toLocaleString(),
      subQuantity: item.subQuantity ?? "",
      subUomName: item.subUomName ?? "",
      totalAmount:
        dataOutWard.tblItemTransactionHeaderCommand.sourceType === "XUAT_BAN"
          ? item.soPrice &&
            (
              Number(item.soPrice) * (item.primaryQuantity || 0)
            ).toLocaleString()
          : item.poPrice &&
            (
              Number(item.poPrice) * Number(item.primaryQuantity || 0)
            ).toLocaleString(),
      status: item.status ?? "",
      note: item.note ?? "",
    }));

    const formattedData = [
      headers.map((h) => h.header),
      ...dataToExport.map((item) => Object.values(item)),
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    let currentDate = new Date();
    let day = currentDate.getDate();
    let month = currentDate.getMonth() + 1;
    let year = currentDate.getFullYear();
    let hours = currentDate.getHours();
    let minutes = currentDate.getMinutes();
    let seconds = currentDate.getSeconds();

    let formattedDate = `${day < 10 ? "0" + day : day}-${
      month < 10 ? "0" + month : month
    }-${year}_${hours < 10 ? "0" + hours : hours}-${
      minutes < 10 ? "0" + minutes : minutes
    }-${seconds < 10 ? "0" + seconds : seconds}`;
    XLSX.utils.book_append_sheet(workbook, worksheet, "Phiếu xuất kho");
    XLSX.writeFile(workbook, `Phieu_xuat_kho_${formattedDate}.xlsx`);
  };

  const handleSheetSelection = async () => {
    if (!selectedSheets || selectedSheets.length === 0) {
      NotificationExtension.Warn("Không có sheets để chọn");
      return;
    }

    if (!workbook) {
      NotificationExtension.Warn("No workbook loaded");
      return;
    }
    const listSerials = selectedSheets.flatMap((sheetName) => {
      const sheet = workbook.Sheets[sheetName];
      const jsonData: { Serial?: string | number }[] = XLSX.utils.sheet_to_json(
        sheet,
        { raw: false },
      );
      return jsonData
        .map((row) => (row.Serial !== undefined ? String(row.Serial) : ""))
        .filter((serial) => serial.trim() !== "");
    });

    const uniqueSerials = [...new Set(listSerials)];

    if (uniqueSerials && uniqueSerials.length > 5000) {
      NotificationExtension.Warn(
        "Số lượng serial vượt quá 5000, vui lòng kiểm tra lại",
      );
      return;
    }

    const skip = (currentPage - 1) * pageSize;

    const _sourceType =
      dataOutWard.tblItemTransactionHeaderCommand?.sourceType ?? "";
    const _sourceCode =
      dataOutWard.tblItemTransactionHeaderCommand?.sourceCode ?? sourceCodeRef;
    const _invId = dataOutWard.tblItemTransactionHeaderCommand?.fromInvId ?? 0;
    try {
      const params = new URLSearchParams({
        KeySearch: debounced,
        SourceCode: _sourceCode,
        Skip: String(0),
        Take: String(500),
        // Skip: skip.toString(),
        // Take: pageSize.toString(),
        Type: _sourceType,
      });

      const body = {
        KeySearch: debounced,
        SourceCode: _sourceCode,
        Skip: 0, // hoặc skip
        Take: 500, // hoặc pageSize
        Type: _sourceType,
        ListSerials: uniqueSerials, // truyền danh sách serials
      };

      if (uniqueSerials.length === 0) {
        NotificationExtension.Fails("Không tìm thấy serial trong tệp Excel.");
        setOpenModal(false); // Close modal after selection
        return;
      }

      const url = `/api/v1/TblItemTransaction/search-list-serial-item-transaction`;

      const response = await repositoryPos.post<
        MessageResponse<TblInventorySerialOrderDetailOnHand[]>
      >(url, body);

      if (response && response.success) {
        const responseData = response.data;
        if (Array.isArray(responseData)) {
          const updatedResponseData = responseData.map((item) => ({
            ...item,
            primaryQuantity: 1,
          }));

          const checkData = [...dataSerialOnHand, ...updatedResponseData];

          // Loại bỏ phần tử trùng serial
          const uniqueData = checkData.filter(
            (item, index, self) =>
              index === self.findIndex((t) => t.serial === item.serial),
          );

          const checkQuantityBy =
            _sourceType === "XUAT_LINH_KIEN_SAN_XUAT"
              ? "limitQuantity"
              : "primaryQuantity";
          if (checkExceedQuantityFound(uniqueData, checkQuantityBy)) {
            NotificationExtension.Warn(
              "Sản phẩm vượt quá số lượng cần xuất, vui loại kiểm tra lại",
            );
          } else {
            if (checkDuplicateCode.includes(serial)) {
              NotificationExtension.Fails("Mã Serial đã được quét !");
            }
            setDataSerialOnHand((prevData) => [...uniqueData]);
            setCheckDuplicateCode((prev) => [
              ...prev,
              ...responseData
                .map((item) => item.serial)
                .filter((serial): serial is string => serial !== null),
            ]);
            // setCheckDuplicateCode((prev) => [
            //   ...prev,
            //   ...responseData
            //     .map((item) => item.serial)
            //     .filter((serial) => serial !== null),
            // ]);
          }
        }
      } else {
        NotificationExtension.Fails(response?.message || "");
      }
      // if (response?.data?.length === 0) {
      //   NotificationExtension.Warn("Không tìm thấy dữ liệu");
      // }
    } catch (error) {
      setIsError(true);
      console.error(error);
    }

    setOpenModal(false);
  };

  const updateItemByKey = <T extends TblInventorySerialOrderDetailOnHandEdit>(
    prev: T[],
    serial: string,
    updateKey: keyof T,
    updateValue: any,
  ): T[] => {
    return prev?.map((item) =>
      item.serial === serial && item[updateKey] !== updateValue
        ? { ...item, [updateKey]: updateValue }
        : item,
    );
  };

  const getOutwardApiUrl = (
    submitAction: string | null,
    sourceType: string | null,
  ): string => {
    const _action = submitAction ?? action.toLowerCase();
    switch (sourceType) {
      case "XUAT_BAN":
        return `/api/v1/Outward/${_action}-sale-order-out-ward`;
      case "XUAT_DOI_TRA":
        return `/api/v1/Outward/${_action}-sale-order-out-ward`;
      case "XUAT_HUY":
        return `/api/v1/Outward/${_action}-request-cancellation-outward`;
      case "XUAT_DIEU_CHINH":
        return `/api/v1/Outward/${_action}-request-adjustment-outward`;
      case "XUAT_DIEU_CHUYEN_CHI_NHANH":
        return `/api/v1/Outward/${_action}-request-transfer-outward`;
      case "XUAT_DIEU_CHUYEN_NOI_BO":
        return `/api/v1/Outward/${_action}-request-transfer-internal-outward`;
      case "XUAT_DIEU_CHUYEN_CHI_NHANH_SERIAL":
        return `/api/v1/Outward/${_action}-request-transfer-serial-outward`;
      case "XUAT_DIEU_CHUYEN_NOI_BO_SERIAL":
        return `/api/v1/Outward/${_action}-request-transfer-internal-serial-outward`;
      case "XUAT_LINH_KIEN_SAN_XUAT":
        return `/api/v1/Outward/${_action}-production-order-outward`;
      case "XUAT_DIEU_CHUYEN_LINH_KIEN_SAN_XUAT":
        return `/api/v1/Outward/${_action}-production-order-transfer-outward`;
      case "XUAT_KHO_BAO_HANH_NCC":
        return `/api/v1/Outward/${_action}-warranty-out-ward`;
      case "XUAT_TRA_NCC":
        return `/api/v1/Outward/${_action}-request-vendor-return-outward`;
      case "XUAT_CONG_CU_DUNG_CU":
        return `/api/v1/Outward/${_action}-request-vendor-return-outward`;
      case "XUAT_KHAC":
        return `/api/v1/Outward/${_action}-request-vendor-return-outward`;
      case "XUAT_THAO_DO":
        return `/api/v1/Outward/${_action}-common`;
      case "XUAT_KHO_BAO_HANH":
        return `/api/v1/Outward/${_action}-common`;
      case "XUAT_DOI_LINH_KIEN":
        return `/api/v1/Outward/${_action}-exchange-serial-outward`;
      case "XUAT_CONG_CU_DUNG_CU":
        return `/api/v1/Outward/${_action}-asset-outward`;
      case "XUAT_HOI_LINH_KIEN_SAN_XUAT":
        return `/api/v1/Outward/${_action}-return-material-outward`;
      default:
        throw new Error("Unknown source type");
    }
  };

  const getAttributes = (
    sourceType: string | null,
  ): { attribute4: string; attribute5: string } => {
    const { fromBranchName, cusCode, cusName, toBranchName } =
      dataOrderDetail?.tblInventoryTransactionModel || {};

    switch (sourceType) {
      case "XUAT_BAN":
        return {
          attribute4: fromBranchName,
          attribute5: `${cusCode} - ${cusName}`,
        };
      case "XUAT_TRA_NCC":
        return {
          attribute4: fromBranchName,
          attribute5: cusName,
        };
      case "XUAT_CONG_CU_DUNG_CU":
        return {
          attribute4: fromBranchName,
          attribute5: cusName,
        };
      case "XUAT_KHAC":
        return {
          attribute4: fromBranchName,
          attribute5: cusName,
        };
      default:
        return {
          attribute4: fromBranchName,
          attribute5: toBranchName,
        };
    }
  };

  const fetchDataPosition = async (fromInvId: number) => {
    try {
      const response = await outward.getSelectItemPosition(fromInvId);

      if (response?.success && Array.isArray(response.data)) {
        const mappedData = response.data.map((p) => ({
          label: p.positionName?.toString() || "",
          value: p.id?.toString() || "",
        }));

        setDataPosition(mappedData);
      } else {
        setDataPosition([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchDataOutWard = async () => {
    const _sourceCode =
      dataOutWard?.tblItemTransactionHeaderCommand?.sourceCode ||
      searchSourceCode;
    const _sourceType =
      dataOutWard?.tblItemTransactionHeaderCommand?.sourceType || sourceType;

    let url = getOutwardApiUrl(null, _sourceType);
    if (
      ["XUAT_TRA_NCC", "XUAT_KHAC", "XUAT_CONG_CU_DUNG_CU"].includes(
        _sourceType,
      )
    ) {
      url += `?prefix=XK&SourceCode=${_sourceCode}&sourceType=${_sourceType}`;
    } else if (sourceType === "XUAT_HOI_LINH_KIEN_SAN_XUAT") {
      url = `/api/v1/Outward/get-return-material-note?prefix=XK&SourceCode=${_sourceCode}`;
    } else {
      url += `?prefix=XK&SourceCode=${_sourceCode}`;
    }
    try {
      const response =
        await repositoryPos.get<MessageResponse<OrderDetailOutWardNew>>(url);
      if (response?.success) {
        setDataOutWard((prevData) => ({
          ...prevData,
          tblItemTransactionHeaderCommand: {
            ...prevData.tblItemTransactionHeaderCommand,
            attribute11:
              response?.data?.tblInventoryTransactionModel?.toBranchId?.toString() ??
              "",
            attribute12:
              dataOutWard.tblItemTransactionHeaderCommand.sourceType ===
                "XUAT_DOI_LINH_KIEN" ||
              dataOutWard.tblItemTransactionHeaderCommand.sourceType ===
                "XUAT_DIEU_CHUYEN_LINH_KIEN_SAN_XUAT"
                ? (response?.data?.tblInventoryTransactionModel?.toInvId?.toString() ??
                  "")
                : "",
            fromInvId:
              response?.data?.tblInventoryTransactionModel?.fromInvId ?? 0,
            transactionCode:
              response?.data?.tblInventoryTransactionModel?.transactionCode,
            ecommerceOrderId:
              response?.data?.tblInventoryTransactionModel?.ecommerceOrderId ??
              null,
            sourceDescription:
              response?.data?.tblInventoryTransactionModel?.sourceDescription ??
              null,
          },
        }));

        let dataDetail = response?.data;

        if (["XUAT_BAN", "XUAT_DOI_TRA"].includes(_sourceType)) {
          const mergedList = mergeInventoryTransactions(
            dataDetail.inventoryTransactionRequestSourceModels,
          );
          dataDetail.inventoryTransactionRequestSourceModels = mergedList;
        }
        //add
        setDataOrderDetail(dataDetail);
        if (response?.data?.tblInventoryTransactionModel?.fromInvId)
          fetchDataPosition(
            response?.data?.tblInventoryTransactionModel?.fromInvId,
          );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  function mergeInventoryTransactions(
    inventoryTransactionRequestSourceModels: detailOrderForOutWardModel[],
  ): detailOrderForOutWardModel[] {
    // Sử dụng Map để nhóm các item theo itemCode
    const groupedItems = new Map<string, detailOrderForOutWardModel>();

    inventoryTransactionRequestSourceModels.forEach((item) => {
      if (!item.itemCode) return; // Bỏ qua nếu itemCode null

      const existingItem = groupedItems.get(item.itemCode);

      if (existingItem) {
        // Nếu đã tồn tại trong nhóm, cộng dồn các trường số
        existingItem.primaryQuantity += item.primaryQuantity;
        existingItem.subQuantity =
          (existingItem.subQuantity ?? 0) + (item.subQuantity ?? 0);
        existingItem.transactionQuantity =
          (existingItem.transactionQuantity ?? 0) +
          (item.transactionQuantity ?? 0);
        existingItem.limitQuantity =
          (existingItem.limitQuantity ?? 0) + (item.limitQuantity ?? 0);
        existingItem.poPrice =
          (existingItem.poPrice ?? 0) + (item.poPrice ?? 0);
        existingItem.soPrice1 =
          (existingItem.soPrice1 ?? 0) + (item.soPrice1 ?? 0);
        existingItem.soPrice2 =
          (existingItem.soPrice2 ?? 0) + (item.soPrice2 ?? 0);
        // Các trường khác như scannedQuantity, remainQuantity
        existingItem.scannedQuantity =
          (existingItem.scannedQuantity ?? 0) + (item.scannedQuantity ?? 0);
        existingItem.remainQuantity =
          (existingItem.remainQuantity ?? 0) + (item.remainQuantity ?? 0);
      } else {
        // Nếu chưa tồn tại, thêm item vào nhóm
        groupedItems.set(item.itemCode, { ...item });
      }
    });

    // Trả về danh sách từ Map
    return Array.from(groupedItems.values());
  }

  useHotkeys([
    [
      "ctrl+S",
      () => {
        handleCreateOutWard("OPEN");
      },
    ],
    [
      "ctrl+Q",
      () => {
        handleCreateOutWard("LOCK", true);
      },
    ],
    ["ctrl+shift+Z", () => toggleCollapse()],
  ]);

  //#endregion

  const fetchdataInventoryTransactionType = async () => {
    const responseOutWard = await getTblInventoryTransactionTypeOutWard();

    const mappedData = responseOutWard.map((type) => ({
      value: type.value,
      label: type.text,
    }));

    const hasXuatHoiLinhKien = mappedData.some(
      (item) => item.value === "XUAT_HOI_LINH_KIEN_SAN_XUAT",
    );

    setDataInventoryTransactionType([
      ...mappedData,
      ...(hasXuatHoiLinhKien
        ? []
        : [
            {
              label: "Xuất hồi linh kiện sản xuất",
              value: "XUAT_HOI_LINH_KIEN_SAN_XUAT",
            },
          ]),
    ]);
  };

  //Chọn kho theo chi nhánh
  const fetchBranches = async () => {
    try {
      let url = `api/v1/TblDmInventory/get-select-by-branch?branchId=${dataOrderDetail?.tblInventoryTransactionModel?.toBranchId}`;
      const response = await repositoryPos.get<MessageResponse<any[]>>(url);
      if (response?.success) {
        setDataInventoryByBranch(response.data);
      }
    } catch (error) {
      setDataSearchSourceCodeOption([]);
    }
  };

  useEffect(() => {
    if (dataOrderDetail?.tblInventoryTransactionModel?.toBranchId)
      fetchBranches();
  }, [dataOrderDetail?.tblInventoryTransactionModel?.toBranchId]);

  const [isPending, startTransaction] = React.useTransition();

  // Get data sản phẩm
  const fetchDataItem = async () => {
    const skip = (currentPage - 1) * pageSize;
    const _sourceType =
      dataOutWard.tblItemTransactionHeaderCommand?.sourceType ?? "";
    const _sourceCode =
      dataOutWard.tblItemTransactionHeaderCommand?.sourceCode ?? sourceCodeRef;
    const _invId = dataOutWard.tblItemTransactionHeaderCommand?.fromInvId ?? 0;
    if (debounced && _sourceType && _sourceCode) {
      try {
        let url = `/api/v1/TblItemTransaction/search-list-serial-item-transaction?KeySearch=${debounced}&SourceCode=${_sourceCode}&Skip=${skip}&Take=${pageSize}&Type=${_sourceType}`;
        if (_sourceType === "XUAT_LINH_KIEN_SAN_XUAT" && _invId) {
          url += `&InvId=${_invId}`;
        }
        const response = await repositoryPos.get(url);
        setTotalPages(
          response.totalCount ? Math.ceil(response.totalCount / pageSize) : 1,
        );
        setDataItem(response?.data || []);
      } catch (error) {
        setDataItem([]);
      }
    }
  };

  const fetchData = async () => {
    const _sourceType =
      dataOutWard?.tblItemTransactionHeaderCommand?.sourceType || sourceType;
    let url = getOutwardApiUrl(null, sourceType);
    try {
      if (sourceCode) {
        url += `?SourceCode=${sourceCode}`;
      } else if (transactionCode) {
        url += `?transactionCode=${transactionCode}`;
      } else {
        url += `?id=${id}`;
      }
      const response = await repositoryPos.get<
        MessageResponse<TblOutwardDetail>
      >(`${url}`);
      if (response?.success && response?.data) {
        setDataOutWard((prevData) => ({
          ...prevData,
          tblItemTransactionHeaderCommand:
            response?.data?.tblInventoryTransactionModel,
        }));

        let dataDetails = response?.data;
        if (["XUAT_BAN", "XUAT_DOI_TRA"].includes(_sourceType)) {
          const mergedList = mergeInventoryTransactions(
            dataDetails.inventoryTransactionRequestSourceModels,
          );

          dataDetails.inventoryTransactionRequestSourceModels = mergedList;
        }
        //add
        setDataOrderDetail((prevData) => ({
          ...prevData,
          inventoryTransactionRequestSourceModels:
            response.data.inventoryTransactionRequestSourceModels?.map(
              (order) => ({
                ...order,
                scannedQuantity: 0,
                primaryQuantity: order.primaryQuantity || 0,
                remainQuantity:
                  (order.primaryQuantity || 0) -
                  (order.transactionQuantity || 0),
              }),
            ),
          tblInventoryTransactionModel:
            response?.data?.tblInventoryTransactionModel,
        }));

        setDataSerialOnHand(
          response.data.inventoryTransactionSerialModels.map((item) => ({
            ...item,
            type: "scanned",
          })) || [],
        );
        setCheckDuplicateCode((prev) => [
          ...prev,
          ...response.data.inventoryTransactionSerialModels
            .map((item) => item.serial)
            .filter((serial): serial is string => serial !== null),
        ]);
        setCheckcDuplicatePositionId((prev) => [
          ...prev,
          ...response.data.inventoryTransactionSerialModels
            .map((item) => Number(item.locatorId))
            .filter((positionId): positionId is number => positionId !== null),
        ]);

        if (response?.data?.tblInventoryTransactionModel?.fromInvId)
          fetchDataPosition(
            response?.data?.tblInventoryTransactionModel?.fromInvId,
          );
      } else {
        setDataOrderDetail(entityOrderOutWard);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setDataOrderDetail(entityOrderOutWard);
    }
  };

  //#region ag grid
  const containerStyle = React.useMemo(
    () => ({ width: "100%", height: height - 100, marginTop: "15px" }),
    [height],
  );

  const myTheme = themeQuartz.withParams({
    fontSize: 12,
    headerFontSize: 14,
    spacing: 5,
    wrapperBorder: true,
    headerRowBorder: true,
    rowBorder: { style: "solid", color: "#dee2e6" },
    columnBorder: { style: "solid", color: "#dee2e6" },
  });

  const handleDeleteSelected = () => {
    const filteredData = dataSerialOnHand?.filter(
      (row) =>
        !selectedRows.some(
          (selected) =>
            selected.serial === row.serial &&
            (selected.itemCode ? selected.itemCode === row.itemCode : true),
        ),
    );
    setDataSerialOnHand(filteredData);

    setCheckDuplicateCode((prevData) =>
      prevData.filter(
        (item) => !selectedRows.some((selected) => selected.serial === item),
      ),
    );
  };

  const getContextMenuItems = React.useCallback(
    (
      params: GetContextMenuItemsParams<TblInventorySerialOrderDetailOnHandEdit>,
    ): (DefaultMenuItem | MenuItemDef)[] => {
      const _number = Number(params?.node?.rowIndex) + 1 || "";
      var result: (DefaultMenuItem | MenuItemDef)[] = [
        {
          // custom item
          name: "Xóa dòng thứ: " + _number,
          disabled: ["DETAIL"].includes(action),
          action: () => {
            deleteItemSerial(String(params?.node?.data?.serial));
          },

          icon: `<div style="width: 20px; height: 20px;"><img style="width: 100%; height: 100%; object-fit: contain;" src="https://cdn-icons-png.flaticon.com/512/3405/3405244.png" alt="icon"/></div>`,
          cssClasses: ["red", "bold"],
        },
        "separator",
        // ...(location?.state?.sourceType === "XUAT_BAN" ||
        // sourceType === "XUAT_BAN"
        //   ? [
        //       {
        //         name: "Nhập Excel",
        //         action: () => {
        //           handleFileUpload();
        //         },
        //         disabled: ["DETAIL"].includes(action),
        //         cssClasses: ["red", "bold"],
        //         icon: `<div style="width: 15px; height: 18px; margin-left: 3px;"><img style="width: 100%; height: 100%; object-fit: contain;" src="https://cdn-icons-png.flaticon.com/512/608/608336.png" alt="icon"/></div>`,
        //       },
        //     ]
        //   : []),
        {
          name: "In linh kiện lắp ráp",
          action: () => {
            // Truyền serial của dòng được chọn vào hàm
            handlePrintLinhKienLapRap(params.node?.data);
          },
          cssClasses: ["red", "bold"],
          icon: `<div style="width: 20px; height: 20px;"><img style="width: 100%; height: 100%; object-fit: contain;" src="https://cdn-icons-png.flaticon.com/512/1055/1055669.png" alt="print icon"/></div>`,
        },
        {
          name: "Import Excel ",
          action: () => {
            handleFileUpload();
          },
          disabled: ["DETAIL"].includes(action),
          cssClasses: ["red", "bold"],
          icon: `<div style="width: 15px; height: 18px; margin-left: 3px;"><img style="width: 100%; height: 100%; object-fit: contain;" src="https://cdn-icons-png.flaticon.com/512/608/608336.png" alt="icon"/></div>`,
        },
        {
          name: "Export Excel",
          action: () => {
            handleExportExcel();
          },
          cssClasses: ["red", "bold"],
          icon: `<div style="width: 20px; height: 20px;"><img style="width: 100%; height: 100%; object-fit: contain;" src="https://cdn-icons-png.flaticon.com/512/9678/9678508.png" alt="icon"/></div>`,
        },
        "separator",
        // "cut",
        // "paste",
        "separator",
        "copy",
        "copyWithHeaders",
        "copyWithGroupHeaders",
      ];
      return result;
    },
    [window, action, dataSerialOnHand, keySearch],
  );
  //Hàm check điều kiện điều chỉnh số lượng
  const isEditableField = (params: any) => {
    const x = dataOrderDetail?.inventoryTransactionRequestSourceModels?.find(
      (item) =>
        item.itemCode === params.data.itemCode ||
        item.serial === params.data.serial,
    );
    return x?.isNoSerial === true || params.data.isNoSerial === true;
  };
  //Hàm điều chỉnh số lượng
  const handlePrimaryQuantityChange = (
    params: CustomCellRendererProps,
    newValue: number,
  ) => {
    setDataSerialOnHand((prev) => {
      const item = prev?.find((item) => item.serial === params.data?.serial);
      if (!item) return prev;
      // Không thay đổi nếu giá trị không đổi
      if (item.primaryQuantity === newValue) return prev;

      return prev?.map((d) =>
        d.serial === params.data?.serial
          ? { ...d, primaryQuantity: newValue }
          : d,
      );
    });
  };

  const openModal = (items: SerialOnHand) => {
    return modals.openConfirmModal({
      title: <Title order={4}>Thông tin serial con</Title>,
      radius: "md",
      size: "90%",
      children: (
        <WarehouseOutWardSerialChildrenV2
          // handleAddPlus={handleAddPlus}
          // handleDeleteRow={handleDeleteRow}
          type="XUAT"
          WarehouseInWardSerialChildren={items}
          action={action}
        />
      ),
      labels: { confirm: "Confirm", cancel: "Cancel" },
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const onCellValueChanged = React.useCallback(
    (
      params: CellValueChangedEvent<TblInventorySerialOrderDetailOnHandEdit>,
    ) => {
      const colId = params.column.getId();
      //Hàm cập nhật giá trị số lượng
      if (colId === "primaryQuantity") {
        const checkNumber =
          dataOrderDetail?.inventoryTransactionRequestSourceModels?.find(
            (ele) =>
              ele.itemCode === params.data?.itemCode ||
              ele.serial === params.data?.serial,
          );

        const numberValue = params.data?.primaryQuantity;
        // Kiểm tra giá trị nhập
        const numericValue = Number(numberValue);
        if (!numberValue || isNaN(numericValue)) {
          NotificationExtension.Warn("Vui lòng nhập số lượng hợp lệ.");
          return;
        }
        //Hiển thị thông báo nếu vượt quá số lượng cho phép
        if (numericValue > Number(checkNumber?.primaryQuantity)) {
          NotificationExtension.Warn("Số lượng vượt quá số lượng cần nhập");
          return;
        }
      }
    },
    [dataPosition, dataSerialOnHand],
  );

  const defaultColDef = React.useMemo<
    ColDef<TblInventorySerialOrderDetailOnHandEdit>
  >(() => {
    return {
      editable: true,
      filter: false,
      floatingFilter: false,
      minWidth: 100,
    };
  }, []);

  const getRowClass = (params: any) => {
    if (!params.data) {
      return "row-error";
    }
    return "";
  };

  const columnDefs = React.useMemo<
    ColDef<TblInventorySerialOrderDetailOnHandEdit>[]
  >(
    () => [
      {
        headerName: "STT",
        field: "index",
        pinned: "left",
        editable: false,
        minWidth: 80,
        maxWidth: 80,
        valueGetter: (params) => Number(params?.node?.rowIndex) + 1,
      },
      {
        field: "positionCode",
        headerName: "Mã vị trí",
        editable: false,
        filter: "agTextColumnFilter",
        minWidth: 150,
      },
      {
        field: "positionName",
        headerName: "Tên vị trí",
        editable: false,
        filter: "agTextColumnFilter",
        minWidth: 150,
      },
      {
        field: "itemCode",
        headerName: "Mã hàng",
        editable: false,
        filter: "agTextColumnFilter",
        minWidth: 150,
      },
      {
        field: "serial",
        headerName: "Serial",
        editable: false,
        filter: "agTextColumnFilter",
        minWidth: 150,
      },
      {
        field: "itemName",
        headerName: "Tên sản phẩm",
        editable: false,
        filter: "agTextColumnFilter",
        minWidth: 150,
      },
      {
        field: "primaryUomCode",
        headerName: "ĐVT1",
        editable: false,
        filter: "agTextColumnFilter",
        minWidth: 70,
      },
      {
        field: "primaryQuantity",
        headerName: "SL1",
        editable: (params: any) => isEditableField(params),
        cellEditor: "agNumberCellEditor",
        filter: "agNumberColumnFilter",
        cellEditorParams: (params: CustomCellRendererProps) => {
          const data =
            dataOrderDetail?.inventoryTransactionRequestSourceModels?.find(
              (ele) =>
                ele.itemCode === params.data?.itemCode ||
                ele.serial === params.data?.serial,
            );
          const maxQuantity = data?.primaryQuantity;
          return {
            values: [0, maxQuantity],
            min: 0,
            max: maxQuantity,
          } as IRichCellEditorParams;
        },
        valueSetter: (params: any) => {
          const newValue = params.newValue;
          handlePrimaryQuantityChange(params, newValue);
          params.data.primaryQuantity = newValue;
          return true;
        },
      },
      {
        field: "poPrice",
        headerName:
          dataOutWard?.tblItemTransactionHeaderCommand?.sourceType ===
          "XUAT_BAN"
            ? "Giá bán"
            : "Giá nhập",
        editable: false,
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        minWidth: 100,
        valueGetter: (params) => {
          const x =
            dataOutWard?.tblItemTransactionHeaderCommand?.sourceType ===
            "XUAT_BAN"
              ? params.data?.soPrice && params.data?.soPrice?.toLocaleString()
              : params.data?.poPrice && params.data?.poPrice?.toLocaleString();
          return x;
        },
      },
      {
        field: "subQuantity",
        headerName: "SL2",
        editable: false,
        filter: "agTextColumnFilter",
        minWidth: 150,
      },
      {
        field: "subUomName",
        headerName: "ĐVT2",
        editable: false,
        filter: "agTextColumnFilter",
        minWidth: 150,
      },
      // {
      //   headerName: "Giá theo ĐVT2",
      //   editable: false,
      //   filter: "agTextColumnFilter",
      //   minWidth: 150,
      // },
      {
        field: "totalAmount",
        headerName: "Thành tiền",
        editable: false,
        cellEditor: "agNumberCellEditor",
        filter: "agNumberColumnFilter",
        minWidth: 100,
        valueGetter: (params) => {
          const x =
            dataOutWard.tblItemTransactionHeaderCommand.sourceType ===
            "XUAT_BAN"
              ? params.data?.soPrice &&
                (
                  Number(params.data?.soPrice) *
                  (params.data?.primaryQuantity || 0)
                ).toLocaleString()
              : params.data?.poPrice &&
                (
                  Number(params.data?.poPrice) *
                  Number(params.data?.primaryQuantity || 0)
                ).toLocaleString();
          return x;
        },
      },
      {
        field: "serialStatus",
        headerName: "Tình trạng",
        editable: false,
        filter: "agTextColumnFilter",
        minWidth: 150,
      },
      {
        field: "attribute11",
        headerName: "Ghi chú tình trạng",
        editable: false,
        filter: "agTextColumnFilter",
        minWidth: 200,
      },
      {
        field: "note",
        headerName: "Ghi chú",
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        minWidth: 200,
      },
      {
        field: "action",
        headerName: "Thao Tác",
        pinned: "right",
        cellRenderer: (params: any) => {
          return (
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                {![
                  "XUAT_LINH_KIEN_SAN_XUAT",
                  "XUAT_DIEU_CHUYEN_LINH_KIEN_SAN_XUAT",
                ].includes(
                  sourceType ??
                    dataOutWard.tblItemTransactionHeaderCommand.sourceType,
                ) && (
                  <>
                    <Tooltip
                      label={`${
                        params?.data?.tblInventoryChildSerialOnhandCommands
                          ?.length > 0
                          ? "Thông tin serial con"
                          : "Chưa có serial con"
                      } `}
                    >
                      <ActionIcon
                        // disabled={!row?.original?.check}
                        onClick={() => {
                          return openModal(params?.data);
                        }}
                        bd={
                          "0.3px solid " +
                          (params?.data?.tblInventoryChildSerialOnhandCommands
                            ?.length > 0
                            ? "violet"
                            : "orange")
                        }
                        variant="light"
                        aria-label="Settings"
                        color={
                          params?.data?.tblInventoryChildSerialOnhandCommands
                            ?.length > 0
                            ? "violet"
                            : "orange"
                        }
                      >
                        <IconPencilDiscount size={20} stroke={1.5} />
                      </ActionIcon>
                    </Tooltip>
                  </>
                )}
                <Tooltip label="Xóa">
                  <ActionIcon
                    disabled={
                      dataOutWard.tblItemTransactionHeaderCommand.status ===
                        "LOCK" || ["DETAIL"].includes(action)
                    }
                    variant="light"
                    aria-label="Settings"
                    color="red"
                    onClick={async () => {
                      deleteItemSerial(
                        params.data.serial,
                        params.data.locatorId,
                      );
                    }}
                  >
                    <IconTrash size={20} stroke={1.5} />
                  </ActionIcon>
                </Tooltip>
              </Box>
            </Box>
          );
        },
        editable: false,
        minWidth: 100,
        maxWidth: 100,
      },
    ],
    [
      dataOutWard,
      locker,
      action,
      changeSourceType,
      dataPosition,
      dataSerialOnHand,
    ],
  );
  //#endregion

  //#region useEffects
  useEffect(() => {
    const fetchAllData = async () => {
      try {
        await Promise.all([fetchdataInventoryTransactionType()]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    const userLogin = localStorage.getItem("userLogin");
    if (userLogin) setUserInfo(JSON.parse(userLogin));

    // Chỉ load dữ liệu theo id/transactionCode ở đây.
    // Trường hợp CREATE theo sourceCode đã có useEffect theo sourceCode xử lý
    // (effect đó cũng chạy ở lần render đầu tiên) nên không gọi lại ở đây
    // để tránh call API 2 lần.
    if (id || transactionCode) {
      fetchData();
    }

    fetchAllData();
  }, []);

  useEffect(() => {
    setDataOutWard((prevData) => ({
      ...prevData,
      tblItemTransactionHeaderCommand: {
        ...prevData.tblItemTransactionHeaderCommand,
        departmentId: userInfo?.depId || null,
      },
    }));
  }, [userInfo]);

  useEffect(() => {
    const _sourceType = dataOutWard.tblItemTransactionHeaderCommand.sourceType;
    const exceedQuantityFound =
      dataOrderDetail?.inventoryTransactionRequestSourceModels?.some(
        (order) => {
          const matchingOrder = dataSerialOnHand
            .filter((item) => {
              const checkItem = _sourceType?.includes("SERIAL")
                ? item.serial === order.serial
                : item.itemId === order.itemId ||
                  item.itemCode === order.itemCode;
              return checkItem;
            })
            .map((item) => item.primaryQuantity || 0);

          if (matchingOrder) {
            const totalQuantity = matchingOrder.reduce(
              (acc, curr) => acc + curr,
              0,
            ); // Tính tổng số lượng

            const orderQuantity = order.primaryQuantity ?? 0;
            const remainQuantity = orderQuantity - totalQuantity || 0;

            return remainQuantity < 0;
          }

          return false;
        },
      );

    if (exceedQuantityFound) {
      setIsExceedQuantity(true);
    } else {
      setIsExceedQuantity(false);
    }

    setDataOrderDetail((prevData) => ({
      ...prevData,
      inventoryTransactionRequestSourceModels:
        prevData.inventoryTransactionRequestSourceModels?.map((order) => {
          const quantities = dataSerialOnHand
            ?.filter((item) => {
              const checkItem =
                _sourceType?.includes("SERIAL") ||
                _sourceType?.includes("SERIAL")
                  ? item.serial === order.serial ||
                    item.sourceLineId === order.sourceLineId
                  : item.itemId === order.itemId ||
                    item.itemCode === order.itemCode;
              return checkItem;
            })
            ?.map((item) => item.primaryQuantity || 0);

          const totalQuantity = quantities.reduce((acc, curr) => acc + curr, 0); // Tính tổng số lượng

          const orderQuantity = order.primaryQuantity ?? 0;
          const orderTransferQuantity = order.transactionQuantity ?? 0;
          const remainQuantity =
            orderQuantity - (orderTransferQuantity + totalQuantity) || 0;
          const priceItem =
            _sourceType === "XUAT_BAN"
              ? (order.soPrice1 ?? 0)
              : (order.poPrice ?? 0);

          return action === "CREATE"
            ? {
                ...order,
                scannedQuantity: totalQuantity,
                remainQuantity: remainQuantity,
                priceItem: priceItem * totalQuantity,
              }
            : {
                ...order,
                scannedQuantity: totalQuantity,
                remainQuantity: remainQuantity,
                priceItem: priceItem * totalQuantity,
              };
        }),
    }));
  }, [dataSerialOnHand]);

  useEffect(() => {
    const _sourceType = dataOutWard.tblItemTransactionHeaderCommand.sourceType;
    const newColumnVisibility = getColumnVisibility();
    // if (action === "DETAIL") {
    //   if (gridRef.current?.api) {
    //     gridRef.current.api.setColumnsVisible(["action"], false); // Ẩn cột action
    //   }
    // }
    if (tableDetail) {
      tableDetail.setColumnVisibility(newColumnVisibility);
    }

    if (_sourceType === "XUAT_LINH_KIEN_SAN_XUAT") {
      if (gridRef.current?.api) {
        gridRef.current.api.setColumnsVisible(["subQuantity", "subUom"], false);
      }
    }
    // Clear input field
    if (action === "CREATE") {
      setDataSearchSourceCodeOption([]);
      setDataOutWard({
        ...outWardEntity,
        tblItemTransactionHeaderCommand: {
          ...outWardEntity.tblItemTransactionHeaderCommand,
          sourceType: _sourceType,
          // sourceCode: null,
        },
      });
      setDataOrderDetail(entityOrderOutWard);
      setDataSerialOnHand([]);
      setCheckDuplicateCode([]);
    }

    if (_sourceType) {
      setIsLockForOrder(_sourceType === "XUAT_BAN");
    } else {
      setIsLockForOrder(false);
    }
  }, [dataOutWard.tblItemTransactionHeaderCommand.sourceType, gridRef.current]);

  useEffect(() => {
    if (action !== "CREATE") {
      return;
    }
    const _sourceType = dataOutWard.tblItemTransactionHeaderCommand.sourceType;
    const _sourceCode = dataOutWard.tblItemTransactionHeaderCommand.sourceCode;
    // Clear input field
    setDataOutWard({
      ...outWardEntity,
      tblItemTransactionHeaderCommand: {
        ...outWardEntity.tblItemTransactionHeaderCommand,
        sourceType: _sourceType,
        sourceCode: _sourceCode,
      },
    });
    setDataOrderDetail(entityOrderOutWard);
    setDataSerialOnHand([]);
    setCheckDuplicateCode([]);
  }, [dataOutWard.tblItemTransactionHeaderCommand.sourceCode]);

  useEffect(() => {
    const _sourceType = dataOutWard.tblItemTransactionHeaderCommand.sourceType;
    if (
      _sourceType === "XUAT_BAN" &&
      dataOrderDetail?.inventoryTransactionRequestSourceModels.length > 0
    ) {
      const variance = checkVarianceItem(
        dataOrderDetail?.inventoryTransactionRequestSourceModels,
        "primaryQuantity",
      );
      if (!variance.isVariance) {
        setIsLockForOrder(false);
      } else {
        setIsLockForOrder(true);
      }
    }
  }, [dataOrderDetail?.inventoryTransactionRequestSourceModels]);

  useEffect(() => {
    // Khi có id/transactionCode thì fetchData() đã lấy dữ liệu, không gọi thêm
    if (id || transactionCode) return;
    if (
      dataOutWard.tblItemTransactionHeaderCommand?.sourceType &&
      dataOutWard.tblItemTransactionHeaderCommand?.sourceCode &&
      action === "CREATE"
    ) {
      fetchDataOutWard();
    }
  }, [dataOutWard.tblItemTransactionHeaderCommand?.sourceCode]);

  useEffect(() => {
    if (debounced && debounced.length > 2) {
      startTransaction(() => {
        fetchDataItem();
      });
    } else {
      setDataItem([]);
    }
  }, [debounced, currentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [debounced]);

  useEffect(() => {
    const updateMainContentWidth = () => {
      const containerWidth = containerRef.current?.offsetWidth || 0;
      const sidePanelWidth = sidePanelRef.current?.offsetWidth || 0;
      const calculatedMainWidth = isCollapse
        ? containerWidth
        : containerWidth - sidePanelWidth;
      setMainContentWidth(calculatedMainWidth);
    };

    const containerObserver = new ResizeObserver(updateMainContentWidth);
    const sidePanelObserver = new ResizeObserver(updateMainContentWidth);

    if (containerRef.current) containerObserver.observe(containerRef.current);
    if (sidePanelRef.current) sidePanelObserver.observe(sidePanelRef.current);

    updateMainContentWidth();

    return () => {
      if (containerRef.current)
        containerObserver.unobserve(containerRef.current);
      if (sidePanelRef.current)
        sidePanelObserver.unobserve(sidePanelRef.current);
    };
  }, [isCollapse]);

  useEffect(() => {
    fetchDataBranch();
  }, []);
  //#endregion

  const columnsOrderDetail = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "index",
        header: "STT",
        Cell: ({ row }) => row.index + 1,
        size: 30,
        enableClickToCopy: false,
      },
      {
        accessorKey: "itemCode",
        header: "Mã hàng",
        footer: "Tổng:",
        size: 30,
        Cell: ({ row }: any) => (
          <Text
            onClick={() => {
              if (!["DETAIL"].includes(action)) {
                setKeySearch(row.original.itemCode);
                setSerial("");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }
            }}
            color="#228be6"
            variant="subtle"
            size="xs"
            p="4px 8px"
            fw={700}
          >
            {row.original.itemCode}
          </Text>
        ),
        Footer(props) {
          return (
            <div>
              <Text c="red" fw={800}>
                {props.column.columnDef.footer}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "serial",
        header: "Serial",
        size: 30,
      },
      {
        accessorKey: "itemName",
        header: "Tên sản phẩm",
        Cell: ({ renderedCellValue }) => (
          <Text size="sm">{renderedCellValue}</Text>
        ),
      },
      {
        accessorKey: "primaryUom",
        header: "ĐVT1",
        size: 30,
      },
      {
        accessorKey: "primaryQuantity",
        header: "SL1",
        size: 30,
      },
      {
        accessorKey: "poPrice",
        header:
          dataOutWard.tblItemTransactionHeaderCommand.sourceType === "XUAT_BAN"
            ? "Giá bán"
            : "Giá nhập",
        size: 30,
        Footer({ table }: any) {
          const total = table
            .getRowModel()
            .rows.reduce(
              (sum: number, row: any) => sum + (row.original.poPrice || 0),
              0,
            );

          return (
            <Text c="red" fw={800}>
              <Flex gap={10}>
                <NumberFormatter value={total} thousandSeparator />
              </Flex>
            </Text>
          );
        },
      },
      {
        accessorKey: "subQuantity",
        header: "SL2",
        size: 30,
      },
      {
        accessorKey: "subUom",
        header: "ĐVT2",
        size: 30,
      },
      {
        accessorKey: "limitQuantity",
        header: "SL định mức ",
        size: 30,
      },
      {
        accessorKey: "subPrice",
        header: "Giá theo ĐVT2",
        size: 30,
      },
      {
        accessorKey: "totalAmount",
        header: "Thành tiền",
        Cell: ({ row }) => (
          <Text size="sm">
            {dataOutWard.tblItemTransactionHeaderCommand.sourceType ===
            "XUAT_BAN"
              ? row.original.soPrice1 &&
                (
                  Number(row.original.soPrice1) *
                  (row.original.primaryQuantity || 0)
                ).toLocaleString()
              : row.original.poPrice &&
                (
                  Number(row.original.poPrice) *
                  Number(row.original.primaryQuantity || 0)
                ).toLocaleString()}
          </Text>
        ),
        Footer({ table }: any) {
          const total = table
            .getRowModel()
            .rows.reduce((sum: number, row: any) => {
              const quantity = row.original.primaryQuantity || 0;
              const price =
                dataOutWard.tblItemTransactionHeaderCommand.sourceType ===
                "XUAT_BAN"
                  ? Number(row.original.soPrice1 || 0)
                  : Number(row.original.poPrice || 0);

              return sum + price * quantity;
            }, 0);

          return (
            <Text c="red" fw={800}>
              <Flex gap={10}>
                <NumberFormatter value={total} thousandSeparator />
              </Flex>
            </Text>
          );
        },
      },

      // {
      //   accessorKey: "itemStatus",
      //   header: "Tình trạng",
      // },
      {
        accessorKey: "note",
        header: "Ghi chú",
      },
      {
        accessorKey: "deviated",
        header: "Lệch",
        enableClickToCopy: false,
        size: 50,
        Cell: ({ row }) => {
          const primaryQuantity =
            changeSourceType === "XUAT_LINH_KIEN_SAN_XUAT"
              ? row.original.limitQuantity
              : row.original.primaryQuantity || 0;
          return (
            <Text fw={"bold"} c={"red"} size="sm">
              {(row.original.scannedQuantity || 0) - primaryQuantity}
            </Text>
          );
        },
      },
    ],
    [
      dataSerialOnHand,
      dataOrderDetail.inventoryTransactionRequestSourceModels,
      dataOutWard.tblItemTransactionHeaderCommand.sourceType,
      changeSourceType,
    ],
  );

  const tableDetail = useMantineReactTable({
    columns: columnsOrderDetail,
    data: dataOrderDetail?.inventoryTransactionRequestSourceModels ?? [],
    positionToolbarAlertBanner: "bottom",
    enableTopToolbar: false,
    enableClickToCopy: true,
    enableStickyFooter: true,
    enableToolbarInternalActions: false,
    enableColumnActions: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["index"],
        right: ["deviated"],
      },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: {
        maxHeight: height * 0.67,
        minHeight: height * 0.67,
      },
    },
    enableStickyHeader: true,
    enablePagination: false,
    enableBottomToolbar: false,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "normal",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      showAlertBanner: isError,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  // console.log("location", location);
  // console.log("changeSourceType", changeSourceType);
  //#endregion

  const attribute3 = dataOutWard?.tblItemTransactionHeaderCommand?.attribute3;
  let parsedData: OrderDetail | null = null;

  try {
    parsedData = attribute3 ? JSON.parse(attribute3) : null;
  } catch (error) {
    console.error("Error parsing JSON:", error);
  }

  return (
    <Box>
      <Modal
        opened={openModals}
        onClose={() => setOpenModal(false)}
        title={<Title order={4}>Vui lòng chọn Sheet từ file excel</Title>}
      >
        {sheetNames.map((sheet, index) => (
          <Checkbox
            mt={15}
            key={index}
            label={<Text fw={500}>{sheet}</Text>}
            checked={selectedSheets.includes(sheet)}
            onChange={(e) => {
              setSelectedSheets(e.target.checked ? [sheet] : []); //chỉ chọn 1
              // setSelectedSheets((prev) =>
              //   e.target.checked
              //     ? [...prev, sheet]   //Cho chọn nhiều
              //     : prev.filter((item) => item !== sheet)
              // );
            }}
          />
        ))}
        <Group mt={15} justify="flex-end">
          <Button
            leftSection={<IconCheck size={16} />}
            onClick={handleSheetSelection}
            color="#228be6"
            variant="filled"
          >
            Xác nhận
          </Button>
        </Group>
      </Modal>
      <_breadcrumb></_breadcrumb>
      <Flex
        ref={headerRef}
        direction={isSmallScreen1250 ? "column" : "row"}
        justify={isSmallScreen1250 ? "center" : "space-between"}
        align={"center"}
        gap={isSmallScreen1250 ? "xs" : "0px"}
      >
        <Flex gap={15}>
          <Flex
            gap="md"
            justify="flex-start"
            align="center"
            direction="row"
            wrap="wrap"
          >
            <Group gap={20}>
              <Text c={"red"} fw={700}>
                Loại phiếu
              </Text>
              <Select
                searchable
                clearable
                w={isSmallScreen1250 ? 250 : 300}
                placeholder="Chọn loại phiếu"
                disabled={
                  dataOutWard.tblItemTransactionHeaderCommand.status ===
                    "LOCK" ||
                  sourceCode ||
                  isSave ||
                  ["DETAIL", "EDIT"].includes(action)
                }
                data={updatedDataInventoryTransactionType}
                value={
                  dataOutWard.tblItemTransactionHeaderCommand.sourceType?.toString() ||
                  ""
                }
                onChange={(value) => {
                  handleChangeValueInput(value || "", "sourceType");
                }}
              />
            </Group>
          </Flex>
        </Flex>
        <Box my={"10px"}>{titleSell()}</Box>
      </Flex>
      <Box
        style={{
          maxHeight: `${height}px`,
          minHeight: `${height}px`,
        }}
      >
        <Box
          style={{
            display: "flex",
            flexDirection: isSmallScreen1250 ? "column" : "row",
            width: "max-width",
          }}
          ref={containerRef}
        >
          {!isCollapse && (
            <Box
              style={{
                flexShrink: 0,
                position: isSmallScreen1250 ? "relative" : "sticky",
                top: isSmallScreen1250 ? "0px" : "60px",
                transition: "width 0.3s ease, max-width 0.3s ease",
                display: "flex",
                alignItems: "stretch",
                overflow: "hidden",
                height: "100%",
                width: "fit-content",
              }}
              ref={sidePanelRef}
            >
              <Collapse
                in={!isCollapse}
                transitionDuration={100}
                transitionTimingFunction="ease-in-out"
              >
                <Fieldset
                  w="fit-content"
                  h="100%"
                  legend="Thông tin chung"
                  p={5}
                >
                  {renderMainOutWard()}
                </Fieldset>
              </Collapse>
            </Box>
          )}
          <Box
            style={{
              flexGrow: 1,
              flexShrink: 0,
              width: `${mainContentWidth}px`,
              transition: "width 0.3s ease",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <Fieldset
              w={"max-width"}
              p={10}
              pb={0}
              legend={
                changeSourceType === "XUAT_LINH_KIEN_SAN_XUAT"
                  ? "Linh kiện"
                  : "Bên xuất"
              }
            >
              <Group>
                <Flex style={{ width: "100%" }}>
                  <Flex gap={15} w={"100%"} justify="start" align={"center"}>
                    {TextTransactionHeader()}
                    {/* <Button
              leftSection={<IconPlus size={14} />}
              variant="filled"
              color="#228be6"
              onClick={handleAddProduct}
              disabled={
                dataOutWard.tblItemTransactionHeaderCommand.status === "LOCK"
              }
            >
              Thêm barcode
            </Button> */}
                    {MenuDataOutWart()}
                  </Flex>
                  <Flex
                    direction={"row"}
                    align="center"
                    justify={"flex-end"}
                    pr={10}
                    gap={15}
                  >
                    <Text style={{ whiteSpace: "nowrap" }} fw={700}>
                      Số lượng:
                    </Text>
                    <Text c="red" fw={700}>
                      <NumberFormatter
                        value={
                          dataSerialOnHand?.reduce(
                            (total, ele) => total + Number(ele.primaryQuantity),
                            0,
                          ) || 0
                        }
                        thousandSeparator
                      />
                    </Text>
                  </Flex>
                </Flex>
              </Group>
              <div style={containerStyle}>
                <AgGridReact<TblInventorySerialOrderDetailOnHandEdit>
                  ref={gridRef}
                  cellSelection={true}
                  onCellValueChanged={onCellValueChanged}
                  rowData={dataSerialOnHand}
                  theme={myTheme}
                  columnDefs={columnDefs}
                  defaultColDef={defaultColDef}
                  suppressColumnVirtualisation={true}
                  suppressRowVirtualisation={true}
                  pagination={true}
                  localeText={AG_GRID_LOCALE_VN}
                  paginationPageSize={paginationPageSize}
                  paginationPageSizeSelector={paginationPageSizeSelector}
                  onSelectionChanged={() =>
                    setSelectedRows(
                      gridRef.current?.api.getSelectedRows() || [],
                    )
                  }
                  getContextMenuItems={getContextMenuItems}
                  cacheBlockSize={paginationPageSize}
                  maxBlocksInCache={3}
                  getRowClass={getRowClass}
                  rowSelection={{ mode: "multiRow" }}
                  suppressRowHoverHighlight={true}
                  columnHoverHighlight={true}
                  autoSizeStrategy={{
                    type: "fitCellContents",
                  }}
                  //  getContextMenuItems={getContextMenuItems}
                />
              </div>
              {/* <MantineReactTable table={table} /> */}
              <Group my="10px" justify="end" />
            </Fieldset>
            <Fieldset
              p={10}
              pb={0}
              w={"max-width"}
              legend={
                changeSourceType === "XUAT_LINH_KIEN_SAN_XUAT"
                  ? "Bộ cần lắp"
                  : dataOutWard.tblItemTransactionHeaderCommand.sourceType ===
                      "XUAT_BAN"
                    ? "Thông tin đơn hàng"
                    : "Yêu cầu xuất kho"
              }
            >
              <Box ref={targetRef as React.RefObject<HTMLDivElement>}>
                <MantineReactTable table={tableDetail} />
              </Box>
            </Fieldset>
          </Box>
        </Box>
      </Box>
      {/* {dataPrint && typePrint && ( */}
      <Box style={{ display: "none" }}>
        {changeSourceType === "XUAT_LINH_KIEN_SAN_XUAT" ? (
          <>
            <PrintMfgWip componentRef={componentRef} dataPrint={dataPrint} />
          </>
        ) : changeSourceType === "XUAT_DIEU_CHUYEN_CHI_NHANH_SERIAL" ||
          changeSourceType === "XUAT_DIEU_CHUYEN_CHI_NHANH" ||
          changeSourceType === "XUAT_DIEU_CHUYEN_NOI_BO" ||
          changeSourceType === "XUAT_DIEU_CHUYEN_NOI_BO_SERIAL" ? (
          <>
            <PrintXDCCNSerial
              componentRef={componentRef}
              dataPrint={dataPrint}
            />
          </>
        ) : changeSourceType === "XUAT_BAN" ||
          changeSourceType === "XUAT_DOI_TRA" ||
          changeSourceType === "XUAT_TRA_NCC" ? (
          <>
            {openPrintHandover ? (
              <PrintHandover
                dataPrint={dataPrint}
                componentRef={componentRef}
                valuePrintHandoverModal={valuePrintHandoverModal}
                locationData={locationData}
                dataCommuneMoi={dataCommuneMoi}
              />
            ) : (
              <PrintWarehouseOutWard
                dataPrint={dataPrint}
                typePrint={location?.state?.type}
                userInfo={userInfo}
                currentDate={currentDate}
                componentRef={componentRef}
                locationData={locationData}
                valuePrintOptionModal={valuePrintOptionModal}
                dataCommuneMoi={dataCommuneMoi}
                dataLinhKienLR={dataLinhKienLR}
                valueQRCode={valueQRCode}
                paymentAmounts={paymentSummaryForPrint}
              />
            )}
          </>
        ) : (
          <></>
        )}
        {/* In phiếu cho Nhân viên đi lấy sản phẩm , trước khi xuất kho bán */}
        <PrintPrOutWard
          componentRef2={componentRef2}
          dataPrint={dataOrderDetail?.inventoryTransactionRequestSourceModels}
          sourceCode={location?.state?.sourceCode}
        />

        {/* in list  linh kiện lắp ráp cho cho sản phẩm lắp ráp của bên mình , mục đích để check sp và thời gian baảo hành*/}
        <PrintWarehouseLKLR
          componentRef3={componentRef3}
          dataLinhKienLR={dataLinhKienLR}
          serialLKPrint={serialLKPrint}
          dataOutWard={dataOutWard}
        />
      </Box>
      {/* )} */}
    </Box>
  );
};

export default WarehouseOutWardActionV2;
